import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { Building2, ArrowLeft, Menu, X, Upload, Download, FileText, EqualNot } from 'lucide-react'
import * as XLSX from 'xlsx'
import { generateUnifiedJson as generateUnifiedJsonHelper } from '../../utils/gstr1Helpers'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import GstSidebar from '../../components/dashboard/GstSidebar'
import ExcelDataGrid from '../../components/common/ExcelDataGrid'
import { useError } from '../../contexts/ErrorContext'
import { getStorageItem, setStorageItem } from '../../utils/storage'
import { useClient } from '../../contexts/ClientContext'

// Static Options moved outside component to avoid scope/initialization issues
const placeOfSupplyOptions = [
  { value: '01', label: '01-Jammu & Kashmir' },
  { value: '02', label: '02-Himachal Pradesh' },
  { value: '03', label: '03-Punjab' },
  { value: '04', label: '04-Chandigarh' },
  { value: '05', label: '05-Uttarakhand' },
  { value: '06', label: '06-Haryana' },
  { value: '07', label: '07-Delhi' },
  { value: '08', label: '08-Rajasthan' },
  { value: '09', label: '09-Uttar Pradesh' },
  { value: '10', label: '10-Bihar' },
  { value: '11', label: '11-Sikkim' },
  { value: '12', label: '12-Arunachal Pradesh' },
  { value: '13', label: '13-Nagaland' },
  { value: '14', label: '14-Manipur' },
  { value: '15', label: '15-Mizoram' },
  { value: '16', label: '16-Tripura' },
  { value: '17', label: '17-Meghalaya' },
  { value: '18', label: '18-Assam' },
  { value: '19', label: '19-West Bengal' },
  { value: '20', label: '20-Jharkhand' },
  { value: '21', label: '21-Odisha' },
  { value: '22', label: '22-Chhattisgarh' },
  { value: '23', label: '23-Madhya Pradesh' },
  { value: '24', label: '24-Gujarat' },
  { value: '25', label: '25-Daman & Diu' },
  { value: '26', label: '26-Dadra & Nagar Haveli & Daman & Diu' },
  { value: '27', label: '27-Maharashtra' },
  { value: '29', label: '29-Karnataka' },
  { value: '30', label: '30-Goa' },
  { value: '31', label: '31-Lakshdweep' },
  { value: '32', label: '32-Kerala' },
  { value: '33', label: '33-Tamil Nadu' },
  { value: '34', label: '34-Puducherry' },
  { value: '35', label: '35-Andaman & Nicobar Islands' },
  { value: '36', label: '36-Telangana' },
  { value: '37', label: '37-Andhra Pradesh' },
  { value: '38', label: '38-Ladakh' },
  { value: '97', label: '97-Other Territory' }
]

const uqcOptions = [
  { value: 'BAG', label: 'BAG-BAGS' },
  { value: 'BAL', label: 'BAL-BALE' },
  { value: 'BDL', label: 'BDL-BUNDLES' },
  { value: 'BKL', label: 'BKL-BUCKLES' },
  { value: 'BOU', label: 'BOU-BILLION OF UNITS' },
  { value: 'BOX', label: 'BOX-BOX' },
  { value: 'BTL', label: 'BTL-BOTTLES' },
  { value: 'BUN', label: 'BUN-BUNCHES' },
  { value: 'CAN', label: 'CAN-CANS' },
  { value: 'CBM', label: 'CBM-CUBIC METERS' },
  { value: 'CCM', label: 'CCM-CUBIC CENTIMETERS' },
  { value: 'CMS', label: 'CMS-CENTIMETERS' },
  { value: 'CTN', label: 'CTN-CARTONS' },
  { value: 'DOZ', label: 'DOZ-DOZENS' },
  { value: 'DRM', label: 'DRM-DRUMS' },
  { value: 'GGK', label: 'GGK-GREAT GROSS' },
  { value: 'GMS', label: 'GMS-GRAMMES' },
  { value: 'GRS', label: 'GRS-GROSS' },
  { value: 'GYD', label: 'GYD-GROSS YARDS' },
  { value: 'KGS', label: 'KGS-KILOGRAMS' },
  { value: 'KLR', label: 'KLR-KILOLITRE' },
  { value: 'KME', label: 'KME-KILOMETRE' },
  { value: 'LTR', label: 'LTR-LITRES' },
  { value: 'MLT', label: 'MLT-MILILITRE' },
  { value: 'MTR', label: 'MTR-METERS' },
  { value: 'MTS', label: 'MTS-METRIC TON' },
  { value: 'NOS', label: 'NOS-NUMBERS' },
  { value: 'PAC', label: 'PAC-PACKS' },
  { value: 'PCS', label: 'PCS-PIECES' },
  { value: 'PRS', label: 'PRS-PAIRS' },
  { value: 'QTL', label: 'QTL-QUINTAL' },
  { value: 'ROL', label: 'ROL-ROLLS' },
  { value: 'SET', label: 'SET-SETS' },
  { value: 'SQF', label: 'SQF-SQUARE FEET' },
  { value: 'SQM', label: 'SQM-SQUARE METERS' },
  { value: 'SQY', label: 'SQY-SQUARE YARDS' },
  { value: 'TBS', label: 'TBS-TABLETS' },
  { value: 'TGM', label: 'TGM-TEN GROSS' },
  { value: 'THD', label: 'THD-THOUSANDS' },
  { value: 'TON', label: 'TON-TONNES' },
  { value: 'TUB', label: 'TUB-TUBES' },
  { value: 'UGS', label: 'UGS-US GALLONS' },
  { value: 'UNT', label: 'UNT-UNITS' },
  { value: 'YDS', label: 'YDS-YARDS' },
  { value: 'OTH', label: 'OTH-OTHERS' },
  { value: 'NA', label: 'NA-NOT APPLICABLE' }
]

const invoiceTypeOptions = [
  { value: 'Regular (B2B/B2C)', label: 'Regular (B2B/B2C)', code: 'R' },
  { value: 'Export Without payment of tax', label: 'Export Without payment of tax', code: 'WOPAY', isExport: true },
  { value: 'Export with payment of tax', label: 'Export with payment of tax', code: 'WPAY', isExport: true },
  { value: 'Deemed Export', label: 'Deemed Export', code: 'DE' },
  { value: 'SEZ supply with payment of Tax', label: 'SEZ supply with payment of Tax', code: 'SEWP' },
  { value: 'SEZ supply without payment of Tax', label: 'SEZ supply without payment of Tax', code: 'SEWOP', taxExempt: true },
  { value: 'Exempt', label: 'Exempt', code: 'EXP', taxExempt: true },
  { value: 'Non-GST Supply', label: 'Non-GST Supply', code: 'NGSUP', taxExempt: true }
]

const reverseChargeOptions = [
  { value: 'N', label: 'N' },
  { value: 'Y', label: 'Y' }
]

// Migration mapping for existing data
const invoiceTypeMigration = {
  'Regular B2B': 'Regular (B2B/B2C)',
  'SEZ supplies with payment': 'SEZ supply with payment of Tax',
  'SEZ supplies without payment': 'SEZ supply without payment of Tax',
  'Deemed Exp': 'Deemed Export',
  'Intra-State supplies attracting IGST': 'Regular (B2B/B2C)'
}

// Helper functions defined outside component
const migrateInvoiceType = (oldInvoiceType) => {
  return invoiceTypeMigration[oldInvoiceType] || oldInvoiceType
}

const isTaxExemptInvoiceType = (invoiceType) => {
  const option = invoiceTypeOptions.find(opt => opt.value === invoiceType)
  return option ? option.taxExempt : false
}

const isExportInvoiceType = (invoiceType) => {
  const option = invoiceTypeOptions.find(opt => opt.value === invoiceType)
  return option ? option.isExport : false
}

const getInvoiceTypeCode = (invoiceType) => {
  const option = invoiceTypeOptions.find(opt => opt.value === invoiceType)
  return option ? option.code : 'R'
}

const isHsnService = (hsnCode) => {
  return hsnCode && hsnCode.toString().trim().startsWith('99')
}

const formatDateForJson = (dateStr) => {
  if (!dateStr) return ''
  // If already in DD-MM-YYYY, return as is
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) return dateStr
  // If in YYYY-MM-DD, convert to DD-MM-YYYY
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [year, month, day] = dateStr.split('-')
    return `${day}-${month}-${year}`
  }
  return dateStr
}

const groupInvoicesByPrefix = (invoices) => {
  const groups = {}

  invoices.forEach(invoice => {
    // Extract prefix (everything before the last numeric part)
    const match = invoice.toString().match(/^(.+?)(\d+)$/)
    if (match) {
      const prefix = match[1] || '' // Everything before the number
      if (!groups[prefix]) {
        groups[prefix] = []
      }
      groups[prefix].push(invoice)
    } else {
      // No clear prefix, treat as one group
      if (!groups['']) {
        groups[''] = []
      }
      groups[''].push(invoice)
    }
  })

  return groups
}

const extractNumericPart = (invoice) => {
  const match = invoice.toString().match(/(\d+)$/)
  return match ? parseInt(match[1]) : 0
}

const getPosEnum = (posCode) => {
  if (!posCode) return ''
  const posMapping = {
    '01': '01', '02': '02', '03': '03', '04': '04', '05': '05', '06': '06', '07': '07', '08': '08', '09': '09', '10': '10',
    '11': '11', '12': '12', '13': '13', '14': '14', '15': '15', '16': '16', '17': '17', '18': '18', '19': '19', '20': '20',
    '21': '21', '22': '22', '23': '23', '24': '24', '25': '25', '26': '26', '27': '27', '29': '29', '30': '30', '31': '31',
    '32': '32', '33': '33', '34': '34', '35': '35', '36': '36', '37': '37', '38': '38', '97': '97'
  }
  return posMapping[posCode] || posCode
}

const getPosDisplayName = (posCode) => {
  const posCodeToName = {
    '01': '01-Jammu & Kashmir', '02': '02-Himachal Pradesh', '03': '03-Punjab', '04': '04-Chandigarh', '05': '05-Uttarakhand',
    '06': '06-Haryana', '07': '07-Delhi', '08': '08-Rajasthan', '09': '09-Uttar Pradesh', '10': '10-Bihar', '11': '11-Sikkim',
    '12': '12-Arunachal Pradesh', '13': '13-Nagaland', '14': '14-Manipur', '15': '15-Mizoram', '16': '16-Tripura',
    '17': '17-Meghalaya', '18': '18-Assam', '19': '19-West Bengal', '20': '20-Jharkhand', '21': '21-Odisha', '22': '22-Chhattisgarh',
    '23': '23-Madhya Pradesh', '24': '24-Gujarat', '25': '25-Daman & Diu', '26': '26-Dadra & Nagar Haveli', '27': '27-Maharashtra',
    '29': '29-Karnataka', '30': '30-Goa', '31': '31-Lakshdweep', '32': '32-Kerala', '33': '33-Tamil Nadu', '34': '34-Puducherry',
    '35': '35-Andaman & Nicobar Islands', '36': '36-Telangana', '37': '37-Andhra Pradesh', '38': '38-Ladakh', '97': '97-Other Territory'
  }
  return posCodeToName[posCode] || posCode
}

const isInterStateTransaction = (gstinMaster, placeOfSupply) => {
  if (!gstinMaster || !placeOfSupply) return false
  const gstinMasterFirstTwo = gstinMaster.substring(0, 2)
  const posEnum = getPosEnum(placeOfSupply)
  return gstinMasterFirstTwo !== posEnum
}

const getUqcEnum = (uqcValue) => {
  // If it's already an enum (3 characters), return as is
  if (uqcValue && uqcValue.length === 3) {
    return uqcValue.toUpperCase()
  }

  // If it's a full name, find the corresponding enum
  const uqcOption = uqcOptions.find(option =>
    option.label.toUpperCase() === uqcValue.toUpperCase() ||
    option.label.toUpperCase().includes(uqcValue.toUpperCase())
  )

  return uqcOption ? uqcOption.value : uqcValue
}

const Gstr1Form = () => {
  const navigate = useNavigate()
  const { addError, clearErrors } = useError()
  const { activeClient } = useClient()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  
  // Data State
  const [gstr1Data, setGstr1Data] = useState([])
  const [isDataLoaded, setIsDataLoaded] = useState(false)

  // Calculate default month (previous month)
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth() + 1 // getMonth() returns 0-11, we need 1-12

  let defaultYear = currentYear
  let defaultMonth = currentMonth - 1
  if (defaultMonth === 0) {
    defaultMonth = 12
    defaultYear = currentYear - 1
  }

  const [selectedYear, setSelectedYear] = useState(() => {
    return localStorage.getItem('gst1Year') || defaultYear.toString()
  })
  const [selectedMonth, setSelectedMonth] = useState(() => {
    return localStorage.getItem('gst1Month') || defaultMonth.toString()
  })

  // Dynamic Key Generator
  const getStorageKey = React.useCallback(() => {
    const clientId = activeClient ? activeClient._id : 'guest'
    return `gstr1Data_${clientId}_${selectedYear}_${selectedMonth}`
  }, [activeClient, selectedYear, selectedMonth])

  const [dataKey, setDataKey] = useState(null);

  // Load data asynchronously
  useEffect(() => {
    const key = getStorageKey();
    let isCurrent = true;
    const loadData = async () => {
      try {
        const savedData = await getStorageItem(key);
        if (isCurrent) {
          if (savedData) {
            setGstr1Data(Array.isArray(savedData) ? savedData : []);
          } else {
            setGstr1Data([]);
          }
          setDataKey(key);
          setIsDataLoaded(true);
        }
      } catch (error) {
        console.error('Failed to load GSTR1 data', error);
        if (isCurrent) {
          setDataKey(key);
          setIsDataLoaded(true);
        }
      }
    };
    loadData();
    return () => { isCurrent = false; };
  }, [getStorageKey]);

  // Save data to new storage whenever it changes (only after initial load)
  useEffect(() => {
    if (isDataLoaded && dataKey === getStorageKey()) {
      setStorageItem(getStorageKey(), gstr1Data);
    }
  }, [gstr1Data, dataKey, isDataLoaded, getStorageKey]);
  const [activeTab, setActiveTab] = useState('data-entry')
  const [selectedGstinForSummary, setSelectedGstinForSummary] = useState('')
  const [selectedSections, setSelectedSections] = useState(() => {
    const saved = localStorage.getItem('gstr1SelectedSections')
    return saved ? JSON.parse(saved) : {
      b2b: true,
      b2cl: true,
      b2cs: true,
      cdnr: true,
      cdnur: true,
      hsn: true,
      doc_issue: true,
      exp: true,
      sezwp: true,
      sezwop: true,
      nil: true,
      all: true
    }
  })

  // Manual entry state
  const [isAdding, setIsAdding] = useState(false)
  const [editingId, setEditingId] = useState(null)
  const [newRow, setNewRow] = useState({
    gstinMaster: activeClient?.gstinRegular || '',
    gstinCustomer: '',
    invoiceNo: '',
    invoiceDate: '',
    invoiceValue: '',
    placeOfSupply: '',
    reverseCharge: 'N',
    invoiceType: '',
    rate: '',
    taxableValue: '',
    igst: '0.00',
    cgst: '0.00',
    sgst: '0.00',
    cess: '0.00',
    hsn: '',
    uqc: '',
    quantity: '0'
  })

  // Navigation confirmation state
  const [pendingNavigation, setPendingNavigation] = useState(null)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  // Grid Handlers
  const handleGridDataChange = (newData, rowIndex, columnKey) => {
    let updatedRow = { ...newData[rowIndex] }

    // Auto-calculate taxes if relevant fields change
    if (['taxableValue', 'rate', 'placeOfSupply', 'invoiceType', 'gstinMaster'].includes(columnKey)) {
      const rate = parseFloat(updatedRow.rate) || 0
      const taxableValue = parseFloat(updatedRow.taxableValue) || 0

      // Calculate taxes
      const taxAmount = (taxableValue * rate) / 100

      if (typeof calculateTaxes === 'function') {
        const taxes = calculateTaxes(rate, taxableValue, updatedRow.gstinMaster, updatedRow.placeOfSupply, updatedRow.invoiceType)
        updatedRow = { ...updatedRow, ...taxes }
      } else {
        const isInterState = isInterStateTransaction(updatedRow.gstinMaster || '', updatedRow.placeOfSupply || '')
        if (isInterState) {
          updatedRow.igst = parseFloat(taxAmount.toFixed(2))
          updatedRow.cgst = 0
          updatedRow.sgst = 0
        } else {
          updatedRow.igst = 0
          updatedRow.cgst = parseFloat((taxAmount / 2).toFixed(2))
          updatedRow.sgst = parseFloat((taxAmount / 2).toFixed(2))
        }
      }
    }

    // Auto-fill UQC/Qty for services
    if (columnKey === 'hsn') {
      if (updatedRow.hsn && updatedRow.hsn.toString().trim().startsWith('99')) {
        updatedRow.uqc = 'NA'
        updatedRow.quantity = 0
      }
    }

    // Always auto-calculate Item Total (invoiceValue)
    const finalTaxable = parseFloat(updatedRow.taxableValue) || 0
    const finalIgst = parseFloat(updatedRow.igst) || 0
    const finalCgst = parseFloat(updatedRow.cgst) || 0
    const finalSgst = parseFloat(updatedRow.sgst) || 0
    const finalCess = parseFloat(updatedRow.cess) || 0
    updatedRow.invoiceValue = parseFloat((finalTaxable + finalIgst + finalCgst + finalSgst + finalCess).toFixed(2))

    const newGridData = [...newData]
    newGridData[rowIndex] = updatedRow
    setGstr1Data(newGridData)
  }

  const handleGridRowAdd = () => {
    const newRecord = {
      id: Date.now(),
      gstinMaster: activeClient?.gstinRegular || '',
      gstinCustomer: '',
      invoiceNo: '',
      invoiceDate: '',
      invoiceValue: '',
      placeOfSupply: '',
      reverseCharge: 'N',
      invoiceType: 'Regular (B2B/B2C)',
      rate: 0,
      taxableValue: 0,
      igst: 0,
      cgst: 0,
      sgst: 0,
      cess: 0,
      hsn: '',
      uqc: 'NOS',
      quantity: 0
    }
    setGstr1Data([...gstr1Data, newRecord])
  }

  const handleGridRowDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this row?')) {
      const updatedData = gstr1Data.filter(row => row.id !== id)
      setGstr1Data(updatedData)
    }
  }

  useEffect(() => {
    const handleAiData = (e) => {
      const data = e.detail;
      if (!data) return;

      const payload = (data && data.formType && data.data) ? data.data : data;
      let extractInvoiceData = [];
      
      if (payload.invoices && Array.isArray(payload.invoices)) {
        extractInvoiceData = payload.invoices;
      } else if (payload.data && Array.isArray(payload.data)) {
        extractInvoiceData = payload.data;
      } else if (Array.isArray(payload)) {
        extractInvoiceData = payload;
      } else if (typeof payload === 'object' && payload !== null) {
        const sections = ['b2b', 'b2cl', 'b2cs', 'cdnr', 'cdnur', 'exp', 'sezwp', 'sezwop'];
        sections.forEach(sec => {
          if (Array.isArray(payload[sec])) {
            payload[sec].forEach(secItem => {
              if (Array.isArray(secItem.inv)) {
                const ctin = secItem.ctin || secItem.gstinCustomer || '';
                secItem.inv.forEach(invItem => {
                  const items = invItem.itms || [{}];
                  items.forEach(itm => {
                    const det = itm.itm_det || itm;
                    extractInvoiceData.push({
                      gstinCustomer: ctin,
                      invoiceNo: invItem.inum || invItem.invoiceNo || '',
                      invoiceDate: invItem.idt || invItem.invoiceDate || '',
                      invoiceValue: invItem.val || invItem.invoiceValue || 0,
                      placeOfSupply: invItem.pos || invItem.placeOfSupply || '',
                      reverseCharge: invItem.rchrg || invItem.reverseCharge || 'N',
                      invoiceType: invItem.inv_typ || invItem.invoiceType || 'Regular (B2B/B2C)',
                      rate: det.rt || det.rate || 0,
                      taxableValue: det.txval || det.taxableValue || 0,
                      igst: det.iamt || det.igst || 0,
                      cgst: det.camt || det.cgst || 0,
                      sgst: det.samt || det.sgst || 0,
                      cess: det.csamt || det.cess || 0,
                      hsn: det.hsn_sc || det.hsn || '',
                      uqc: det.uqc || 'NOS',
                      quantity: det.qty || det.quantity || 0
                    });
                  });
                });
              } else {
                extractInvoiceData.push(secItem);
              }
            });
          }
        });

        if (extractInvoiceData.length === 0) {
          Object.values(payload).forEach(val => {
            if (Array.isArray(val)) {
              extractInvoiceData.push(...val);
            }
          });
        }
      }

      if (extractInvoiceData.length > 0) {
        const newInvoices = extractInvoiceData.map(inv => {
          let gstinCustomer = inv.gstinCustomer || inv.ctin || inv.gstin || '';
          let invoiceNo = inv.invoiceNo || inv.inum || inv.invNo || '';
          let date = inv.invoiceDate || inv.idt || inv.date || '';
          if (date && /^\d{2}-\d{2}-\d{4}$/.test(date)) {
             const [day, month, year] = date.split('-');
             date = `${year}-${month}-${day}`;
          }

          let invoiceType = inv.invoiceType || inv.inv_typ || 'Regular (B2B/B2C)';
          let isCreditNote = false;
          if (invoiceType && invoiceType.toLowerCase().includes('credit note')) {
            isCreditNote = true;
            invoiceType = 'Regular (B2B/B2C)'; // Map to standard invoice type
          }

          const parseNum = (val) => {
            if (typeof val === 'string') {
              val = val.replace(/,/g, '');
            }
            const parsed = parseFloat(val);
            return isNaN(parsed) ? 0 : parsed;
          };

          const makeNegative = (val) => {
             const num = parseNum(val);
             return num === 0 ? 0 : -Math.abs(num);
          };

          let placeOfSupply = inv.placeOfSupply || inv.pos || '';
          if (placeOfSupply && typeof placeOfSupply === 'string') {
             const codeMatch = placeOfSupply.match(/^(\d{2})/);
             if (codeMatch) {
                 // Layer 1: Already has a 2-digit code prefix e.g. "27" or "27-Maharashtra"
                 placeOfSupply = codeMatch[1];
             } else {
                 // Layer 2: Fuzzy label match e.g. "Maharashtra" → "27"
                 const opt = placeOfSupplyOptions.find(o => o.label.toLowerCase().includes(placeOfSupply.toLowerCase()));
                 if (opt) {
                     placeOfSupply = opt.value;
                 } else {
                     // Layer 3: Abbreviation / short-form map
                     const abbreviationMap = {
                         'jk': '01', 'j&k': '01', 'jammu and kashmir': '01', 'jammu & kashmir': '01',
                         'hp': '02', 'himachal': '02',
                         'pb': '03', 'punjab': '03',
                         'ch': '04', 'chandigarh': '04',
                         'uk': '05', 'uttarakhand': '05', 'uttaranchal': '05',
                         'hr': '06', 'haryana': '06',
                         'dl': '07', 'delhi': '07',
                         'rj': '08', 'rajasthan': '08',
                         'up': '09', 'uttar pradesh': '09',
                         'br': '10', 'bihar': '10',
                         'sk': '11', 'sikkim': '11',
                         'ar': '12', 'arunachal': '12',
                         'nl': '13', 'nagaland': '13',
                         'mn': '14', 'manipur': '14',
                         'mz': '15', 'mizoram': '15',
                         'tr': '16', 'tripura': '16',
                         'ml': '17', 'meghalaya': '17',
                         'as': '18', 'assam': '18',
                         'wb': '19', 'west bengal': '19',
                         'jh': '20', 'jharkhand': '20',
                         'or': '21', 'od': '21', 'odisha': '21', 'orissa': '21',
                         'cg': '22', 'chhattisgarh': '22',
                         'mp': '23', 'madhya pradesh': '23',
                         'gj': '24', 'gujarat': '24',
                         'dd': '25', 'daman and diu': '25', 'daman & diu': '25',
                         'dn': '26', 'dadra': '26',
                         'mh': '27', 'maharashtra': '27',
                         'ka': '29', 'karnataka': '29',
                         'ga': '30', 'goa': '30',
                         'ld': '31', 'lakshadweep': '31',
                         'kl': '32', 'kerala': '32',
                         'tn': '33', 'tamil nadu': '33', 'tamilnadu': '33',
                         'py': '34', 'pondicherry': '34', 'puducherry': '34',
                         'an': '35', 'andaman': '35',
                         'ts': '36', 'telangana': '36',
                         'ap': '37', 'andhra pradesh': '37', 'andhra': '37',
                         'la': '38', 'ladakh': '38',
                     };
                     const abbr = abbreviationMap[placeOfSupply.toLowerCase().trim()];
                     if (abbr) {
                         placeOfSupply = abbr;
                     } else {
                         const levenshtein = (a, b) => {
                             const m = a.length, n = b.length;
                             const dp = Array.from({ length: m + 1 }, (_, i) =>
                                 Array.from({ length: n + 1 }, (_, j) => (i === 0 ? j : j === 0 ? i : 0))
                             );
                             for (let i = 1; i <= m; i++) {
                                 for (let j = 1; j <= n; j++) {
                                     dp[i][j] = a[i - 1] === b[j - 1]
                                         ? dp[i - 1][j - 1]
                                         : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
                                 }
                             }
                             return dp[m][n];
                         };

                         const input = placeOfSupply.toLowerCase().trim();
                         let bestMatch = null;
                         let bestDist = Infinity;

                         placeOfSupplyOptions.forEach(o => {
                             const fullLabel = o.label.toLowerCase();
                             const namePart = fullLabel.replace(/^\d{2}-/, '');
                             const distFull = levenshtein(input, fullLabel);
                             const distName = levenshtein(input, namePart);
                             const dist = Math.min(distFull, distName);
                             if (dist < bestDist) {
                                 bestDist = dist;
                                 bestMatch = o;
                             }
                         });

                         const maxAllowed = Math.floor(input.length * 0.3);
                         if (bestMatch && bestDist <= maxAllowed) {
                             placeOfSupply = bestMatch.value;
                         } else if (gstinCustomer && gstinCustomer.trim().length >= 2) {
                             const customerCode = gstinCustomer.trim().substring(0, 2);
                             if (placeOfSupplyOptions.some(o => o.value === customerCode)) {
                                 placeOfSupply = customerCode;
                             }
                         }
                     }
                 }
             }
          } else if (!placeOfSupply && gstinCustomer && gstinCustomer.trim().length >= 2) {
             const customerCode = gstinCustomer.trim().substring(0, 2);
             if (placeOfSupplyOptions.some(o => o.value === customerCode)) {
                 placeOfSupply = customerCode;
             }
          }

          let uqc = inv.uqc;
          let quantity = inv.quantity;
          const hsnCode = inv.hsn ? inv.hsn.toString().trim() : '';
          if (isHsnService(hsnCode)) {
            uqc = 'NA';
            quantity = 0;
          }

          const rawTaxable = inv.taxableValue !== undefined ? inv.taxableValue : (inv.txval !== undefined ? inv.txval : 0);
          const rawIgst = inv.igst !== undefined ? inv.igst : (inv.iamt !== undefined ? inv.iamt : 0);
          const rawCgst = inv.cgst !== undefined ? inv.cgst : (inv.camt !== undefined ? inv.camt : 0);
          const rawSgst = inv.sgst !== undefined ? inv.sgst : (inv.samt !== undefined ? inv.samt : 0);
          const rawCess = inv.cess !== undefined ? inv.cess : (inv.csamt !== undefined ? inv.csamt : 0);

          const finalTaxable = isCreditNote ? makeNegative(rawTaxable) : parseNum(rawTaxable);
          const finalIgst = isCreditNote ? makeNegative(rawIgst) : parseNum(rawIgst);
          const finalCgst = isCreditNote ? makeNegative(rawCgst) : parseNum(rawCgst);
          const finalSgst = isCreditNote ? makeNegative(rawSgst) : parseNum(rawSgst);
          const finalCess = isCreditNote ? makeNegative(rawCess) : parseNum(rawCess);
          
          const calculatedInvoiceValue = finalTaxable + finalIgst + finalCgst + finalSgst + finalCess;

          return {
            ...inv,
            id: Date.now() + Math.random(),
            gstinCustomer: gstinCustomer,
            invoiceNo: invoiceNo,
            invoiceDate: date,
            invoiceType: invoiceType,
            placeOfSupply: placeOfSupply,
            invoiceValue: inv.invoiceValue || inv.val ? parseNum(inv.invoiceValue || inv.val) : parseFloat(calculatedInvoiceValue.toFixed(2)),
            taxableValue: finalTaxable,
            igst: finalIgst,
            cgst: finalCgst,
            sgst: finalSgst,
            cess: finalCess,
            rate: inv.rate !== undefined ? parseNum(inv.rate) : (inv.rt !== undefined ? parseNum(inv.rt) : 0),
            reverseCharge: inv.reverseCharge || inv.rchrg || 'N',
            hsn: hsnCode,
            uqc: uqc || 'NOS',
            quantity: quantity || 0,
          };
        });
        
        setGstr1Data(prev => [...prev, ...newInvoices]);
        toast.success(`Imported ${newInvoices.length} records from AI`);
      }
    };
    
    window.addEventListener('aiDataExtracted', handleAiData);
    return () => window.removeEventListener('aiDataExtracted', handleAiData);
  }, []);

  useEffect(() => {
    localStorage.setItem('gst1Year', selectedYear)
  }, [selectedYear])

  useEffect(() => {
    localStorage.setItem('gst1Month', selectedMonth)
  }, [selectedMonth])

  useEffect(() => {
    localStorage.setItem('gstr1SelectedSections', JSON.stringify(selectedSections))
  }, [selectedSections])

  const handleExcelUpload = (event) => {
    const file = event.target.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        const jsonData = XLSX.utils.sheet_to_json(worksheet)

        // Required headers (must be present in Excel)
        const requiredHeaders = [
          'GSTIN (Master)',
          'Place of Supply',
          'Invoice Type',
          'Invoice No.',
          'Invoice Date',
          'Invoice Value',
          'Taxable Value',
          'Rate',
          'IGST',
          'CGST',
          'SGST',
          'HSN',
          'UQC',
          'Quantity',
          'Reverse Charge'
        ]

        // Optional headers (may or may not be present)
        const optionalHeaders = [
          'GSTIN (Customer)',
          'Cess'
        ]

        // Validate required headers
        const headers = Object.keys(jsonData[0] || {})
        const missingHeaders = requiredHeaders.filter(header => !headers.includes(header))

        if (missingHeaders.length > 0) {
          addError(`Missing required headers: ${missingHeaders.join(', ')}`)
          event.target.value = '' // Reset input
          return
        }

        if (jsonData.length === 0) {
          addError('No data found in the Excel file')
          event.target.value = '' // Reset input
          return
        }

        // Validate each row and collect errors
        const validationErrors = []
        const convertedData = jsonData
          .filter(row => Object.values(row).some(value => value !== '' && value != null))
          .map((row, index) => {
            const rowNumber = index + 1
            const errors = []

            // Validate GSTIN Master (required)
            if (!row['GSTIN (Master)'] || row['GSTIN (Master)'].toString().trim() === '') {
              errors.push(`Row ${rowNumber}: GSTIN (Master) is required`)
            } else if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/.test(row['GSTIN (Master)'].toString().trim())) {
              errors.push(`Row ${rowNumber}: GSTIN (Master) format is invalid`)
            }

            // GSTIN (Customer) is optional - no format validation (UINs and other formats allowed)

            // Validate Invoice No (required)
            if (!row['Invoice No.'] || row['Invoice No.'].toString().trim() === '') {
              errors.push(`Row ${rowNumber}: Invoice No. is required`)
            }

            // Validate Invoice Date (required and format)
            if (!row['Invoice Date'] || row['Invoice Date'].toString().trim() === '') {
              errors.push(`Row ${rowNumber}: Invoice Date is required`)
            } else {
              let dateStr = row['Invoice Date'].toString().trim()

              // Check if it's an Excel serial number (numeric)
              if (/^\d+$/.test(dateStr)) {
                const serialNumber = parseInt(dateStr)
                // Convert Excel serial number to date
                const excelEpoch = new Date(1899, 11, 30) // December 30, 1899
                const date = new Date(excelEpoch.getTime() + serialNumber * 24 * 60 * 60 * 1000)

                // Format to DD-MM-YYYY
                const day = String(date.getDate()).padStart(2, '0')
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const year = date.getFullYear()
                dateStr = `${day}-${month}-${year}`
              }

              // Check if it's in DD-MM-YYYY format
              if (!/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
                errors.push(`Row ${rowNumber}: Invoice Date must be in DD-MM-YYYY format (e.g., 23-05-2025)`)
              } else {
                // Validate if it's a valid date
                const [day, month, year] = dateStr.split('-')
                const date = new Date(year, month - 1, day)
                if (date.getDate() != day || date.getMonth() != month - 1 || date.getFullYear() != year) {
                  errors.push(`Row ${rowNumber}: Invoice Date is not a valid date`)
                }
              }
            }

            // Validate required numeric fields (all except Cess)
            const requiredNumericFields = [
              { field: 'Invoice Value', value: row['Invoice Value'] },
              { field: 'Rate', value: row['Rate'] },
              { field: 'Taxable Value', value: row['Taxable Value'] },
              { field: 'IGST', value: row['IGST'] },
              { field: 'CGST', value: row['CGST'] },
              { field: 'SGST', value: row['SGST'] },
              { field: 'Quantity', value: row['Quantity'] }
            ]

            requiredNumericFields.forEach(({ field, value }) => {
              if (value === null || value === undefined || value.toString().trim() === '') {
                errors.push(`Row ${rowNumber}: ${field} is required`)
              } else {
                const numValue = parseFloat(value)
                if (isNaN(numValue)) {
                  errors.push(`Row ${rowNumber}: ${field} must be a valid number`)
                }
                // Removed negative value validation to support credit notes
              }
            })

            // Validate Cess field (optional)
            if (row['Cess'] && row['Cess'].toString().trim() !== '') {
              const numValue = parseFloat(row['Cess'])
              if (isNaN(numValue)) {
                errors.push(`Row ${rowNumber}: Cess must be a valid number`)
              }
              // Removed negative value validation to support credit notes
            }

            // Validate Invoice Type first (required for all transactions)
            const invoiceType = row['Invoice Type'] ? row['Invoice Type'].toString().trim() : ''

            if (invoiceType === '') {
              errors.push(`Row ${rowNumber}: Invoice Type is required`)
            } else {
              // Migrate old invoice type values
              const migratedInvoiceType = migrateInvoiceType(invoiceType)
              const validInvoiceTypes = invoiceTypeOptions.map(opt => opt.value)
              if (!validInvoiceTypes.includes(migratedInvoiceType)) {
                errors.push(`Row ${rowNumber}: Invoice Type must be one of: ${validInvoiceTypes.join(', ')}`)
              }
            }

            // Validate Tax Rate (must be 0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, 28, or 40) - Skip for tax-exempt invoice types
            const migratedInvoiceType = migrateInvoiceType(invoiceType)
            const isTaxExempt = isTaxExemptInvoiceType(migratedInvoiceType)

            // Special validation for export/SEZ with payment - rate cannot be 0
            if (migratedInvoiceType === 'Export with payment of tax' || migratedInvoiceType === 'SEZ supply with payment of Tax') {
              const rate = parseFloat(row['Rate'])
              if (!isNaN(rate) && rate === 0) {
                errors.push(`Row ${rowNumber}: Tax Rate cannot be 0 for "Export with payment of tax" or "SEZ supply with payment of Tax"`)
              }
            }

            if (!isTaxExempt) {
              const rate = parseFloat(row['Rate'])
              if (!isNaN(rate)) {
                const validRates = [0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, 28, 40]
                if (!validRates.includes(rate)) {
                  errors.push(`Row ${rowNumber}: Tax Rate must be one of: 0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, 28, or 40. Current value: ${rate}`)
                }
              }
            }


            // Validate Place of Supply
            if (!row['Place of Supply'] || row['Place of Supply'].toString().trim() === '') {
              errors.push(`Row ${rowNumber}: Place of Supply is required`)
            } else {
              const posValue = row['Place of Supply'].toString().trim()
              const validPosCodes = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '97']
              const validPosNames = [
                '01-Jammu & Kashmir', '02-Himachal Pradesh', '03-Punjab', '04-Chandigarh', '05-Uttarakhand',
                '06-Haryana', '07-Delhi', '08-Rajasthan', '09-Uttar Pradesh', '10-Bihar', '11-Sikkim',
                '12-Arunachal Pradesh', '13-Nagaland', '14-Manipur', '15-Mizoram', '16-Tripura',
                '17-Meghalaya', '18-Assam', '19-West Bengal', '20-Jharkhand', '21-Odisha', '22-Chhattisgarh',
                '23-Madhya Pradesh', '24-Gujarat', '25-Daman & Diu', '26-Dadra & Nagar Haveli', '27-Maharashtra',
                '29-Karnataka', '30-Goa', '31-Lakshadweep', '32-Kerala', '33-Tamil Nadu', '34-Puducherry',
                '35-Andaman & Nicobar Islands', '36-Telangana', '37-Andhra Pradesh', '38-Ladakh', '97-Other Territory'
              ]

              // Check if it's a valid code or full name
              if (!validPosCodes.includes(posValue) && !validPosNames.includes(posValue)) {
                errors.push(`Row ${rowNumber}: Place of Supply must be a valid state code (01-38, 97) or full name (e.g., 01-Jammu & Kashmir)`)
              }
            }

            // Validate Reverse Charge
            if (row['Reverse Charge'] && row['Reverse Charge'].toString().trim() !== '') {
              const rcValue = row['Reverse Charge'].toString().trim().toUpperCase()
              if (!['N', 'Y'].includes(rcValue)) {
                errors.push(`Row ${rowNumber}: Reverse Charge must be 'N' or 'Y'`)
              }
            }


            // Validate HSN (required)
            if (!row['HSN'] || row['HSN'].toString().trim() === '') {
              errors.push(`Row ${rowNumber}: HSN is required`)
            }

            // Validate UQC (required)
            if (!row['UQC'] || row['UQC'].toString().trim() === '') {
              errors.push(`Row ${rowNumber}: UQC is required`)
            } else {
              const uqcValue = row['UQC'].toString().trim()
              const uqcEnum = getUqcEnum(uqcValue)
              const validUqcCodes = ['BAG', 'BAL', 'BDL', 'BKL', 'BOU', 'BOX', 'BTL', 'BUN', 'CAN', 'CBM', 'CCM', 'CMS', 'CTN', 'DOZ', 'DRM', 'GGK', 'GMS', 'GRS', 'GYD', 'KGS', 'KLR', 'KME', 'LTR', 'MLT', 'MTR', 'MTS', 'NOS', 'OTH', 'PAC', 'PCS', 'PRS', 'QTL', 'ROL', 'SET', 'SQF', 'SQM', 'SQY', 'TBS', 'TGM', 'THD', 'TON', 'TUB', 'UGS', 'UNT', 'YDS', 'NA']
              if (!validUqcCodes.includes(uqcEnum)) {
                errors.push(`Row ${rowNumber}: UQC must be a valid unit code (e.g., "BAG" or "BAG-BAGS")`)
              }
            }

            // Auto-correct UQC and Quantity for HSN starting with 99
            const hsnCode = row['HSN'] ? row['HSN'].toString().trim() : ''
            if (isHsnService(hsnCode)) {
              // Auto-correct UQC to NA for service HSN
              row['UQC'] = 'NA'
              // Auto-correct Quantity to 0 for service HSN
              row['Quantity'] = '0'
            }

            // Collect errors for this row
            if (errors.length > 0) {
              validationErrors.push(...errors)
              return null
            }

            try {
              // Convert date if it's an Excel serial number
              // Convert date if it's an Excel serial number
              let invoiceDate = row['Invoice Date'].toString().trim()
              if (/^\d+$/.test(invoiceDate)) {
                const serialNumber = parseInt(invoiceDate)
                const excelEpoch = new Date(1899, 11, 30) // December 30, 1899
                const date = new Date(excelEpoch.getTime() + serialNumber * 24 * 60 * 60 * 1000)
                const day = String(date.getDate()).padStart(2, '0')
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const year = date.getFullYear()
                invoiceDate = `${year}-${month}-${day}` // Store as YYYY-MM-DD
              } else if (/^\d{2}-\d{2}-\d{4}$/.test(invoiceDate)) {
                // Convert DD-MM-YYYY to YYYY-MM-DD for state storage
                const [day, month, year] = invoiceDate.split('-')
                invoiceDate = `${year}-${month}-${day}`
              }

              // Convert Place of Supply to code if it's a full name
              let placeOfSupply = row['Place of Supply'].toString().trim()
              const posNameToCode = {
                '01-Jammu & Kashmir': '01', '02-Himachal Pradesh': '02', '03-Punjab': '03', '04-Chandigarh': '04', '05-Uttarakhand': '05',
                '06-Haryana': '06', '07-Delhi': '07', '08-Rajasthan': '08', '09-Uttar Pradesh': '09', '10-Bihar': '10', '11-Sikkim': '11',
                '12-Arunachal Pradesh': '12', '13-Nagaland': '13', '14-Manipur': '14', '15-Mizoram': '15', '16-Tripura': '16',
                '17-Meghalaya': '17', '18-Assam': '18', '19-West Bengal': '19', '20-Jharkhand': '20', '21-Odisha': '21', '22-Chhattisgarh': '22',
                '23-Madhya Pradesh': '23', '24-Gujarat': '24', '25-Daman & Diu': '25', '26-Dadra & Nagar Haveli': '26', '27-Maharashtra': '27',
                '29-Karnataka': '29', '30-Goa': '30', '31-Lakshadweep': '31', '32-Kerala': '32', '33-Tamil Nadu': '33', '34-Puducherry': '34',
                '35-Andaman & Nicobar Islands': '35', '36-Telangana': '36', '37-Andhra Pradesh': '37', '38-Ladakh': '38', '97-Other Territory': '97'
              }

              if (posNameToCode[placeOfSupply]) {
                placeOfSupply = posNameToCode[placeOfSupply]
              }

              // Calculate tax based on Intra/Inter state logic
              const gstinMasterFirstTwo = row['GSTIN (Master)'].toString().trim().substring(0, 2)
              const posEnum = getPosEnum(placeOfSupply)
              const isIntraState = gstinMasterFirstTwo === posEnum

              const rate = parseFloat(row['Rate']) || 0
              const taxableValue = parseFloat(row['Taxable Value']) || 0
              const taxAmount = (taxableValue * rate) / 100

              let igst = 0
              let cgst = 0
              let sgst = 0

              if (isIntraState) {
                // Intra state: CGST & SGST (half of rate each)
                cgst = Math.round((taxAmount / 2) * 100) / 100
                sgst = Math.round((taxAmount / 2) * 100) / 100
              } else {
                // Inter state: IGST (full rate)
                igst = Math.round(taxAmount * 100) / 100
              }

              // Validate tax calculation with entered values
              const enteredIgst = parseFloat(row['IGST']) || 0
              const enteredCgst = parseFloat(row['CGST']) || 0
              const enteredSgst = parseFloat(row['SGST']) || 0

              // Round to 2 decimal places for comparison
              const roundedEnteredIgst = Math.round(enteredIgst * 100) / 100
              const roundedEnteredCgst = Math.round(enteredCgst * 100) / 100
              const roundedEnteredSgst = Math.round(enteredSgst * 100) / 100

              if (roundedEnteredIgst !== igst) {
                validationErrors.push(`Row ${rowNumber}: IGST calculation mismatch. Expected: ${igst.toFixed(2)}, Entered: ${roundedEnteredIgst.toFixed(2)}`)
              }
              if (roundedEnteredCgst !== cgst) {
                validationErrors.push(`Row ${rowNumber}: CGST calculation mismatch. Expected: ${cgst.toFixed(2)}, Entered: ${roundedEnteredCgst.toFixed(2)}`)
              }
              if (roundedEnteredSgst !== sgst) {
                validationErrors.push(`Row ${rowNumber}: SGST calculation mismatch. Expected: ${sgst.toFixed(2)}, Entered: ${roundedEnteredSgst.toFixed(2)}`)
              }

              // Define missing variables - GSTIN (Customer) is optional (column may not exist)
              const gstinCustomer = (row.hasOwnProperty('GSTIN (Customer)') && row['GSTIN (Customer)'])
                ? row['GSTIN (Customer)'].toString().trim()
                : ''
              const invoiceType = row['Invoice Type'] ? row['Invoice Type'].toString().trim() : ''

              // Migrate invoice type and check if tax-exempt
              const migratedInvoiceType = migrateInvoiceType(invoiceType || 'Regular (B2B/B2C)')
              const isTaxExempt = isTaxExemptInvoiceType(migratedInvoiceType)
              
              const finalIgst = isTaxExempt ? 0 : igst;
              const finalCgst = isTaxExempt ? 0 : cgst;
              const finalSgst = isTaxExempt ? 0 : sgst;
              const cessValue = parseFloat(row['Cess']) || 0;
              const calculatedInvoiceValue = taxableValue + finalIgst + finalCgst + finalSgst + cessValue;

              return {
                id: Date.now() + index,
                gstinMaster: row['GSTIN (Master)'].toString().trim(),
                gstinCustomer: gstinCustomer,
                invoiceNo: row['Invoice No.'].toString().trim(),
                invoiceDate: invoiceDate,
                invoiceValue: parseFloat(calculatedInvoiceValue.toFixed(2)),
                placeOfSupply: placeOfSupply,
                reverseCharge: row['Reverse Charge'] ? row['Reverse Charge'].toString().trim().toUpperCase() : 'N',
                invoiceType: migratedInvoiceType,
                rate: isTaxExempt ? 0 : rate,
                taxableValue: taxableValue,
                igst: finalIgst,
                cgst: finalCgst,
                sgst: finalSgst,
                cess: cessValue,
                hsn: row['HSN'] ? row['HSN'].toString().trim() : '',
                uqc: row['UQC'] ? getUqcEnum(row['UQC'].toString().trim()) : 'NOS',
                quantity: parseFloat(row['Quantity']) || 0,
                type: 'OE'
              }
            } catch (error) {
              validationErrors.push(`Row ${rowNumber}: Error processing data - ${error.message}`)
              return null
            }
          })
          .filter(row => row !== null)

        // Show validation errors if any
        if (validationErrors.length > 0) {
          const errorMessage = `Please correct the following errors before uploading:\n\n${validationErrors.slice(0, 10).join('\n')}${validationErrors.length > 10 ? `\n... and ${validationErrors.length - 10} more errors` : ''}`
          addError(errorMessage, { duration: 10000 })
          event.target.value = ''
          return
        }

        if (convertedData.length === 0) {
          addError('No valid data found in the Excel file')
          event.target.value = ''
          return
        }

        setGstr1Data(convertedData)
        setStorageItem(getStorageKey(), convertedData)
        toast.success(`Successfully imported ${convertedData.length} records from Excel`)
        event.target.value = ''
      } catch (error) {
        console.error('Error processing Excel file:', error)
        console.error('Error details:', error.message)
        console.error('Error stack:', error.stack)
        addError(`Error processing Excel file: ${error.message}. Please check the format and try again.`)
        event.target.value = ''
      }
    }
    reader.readAsArrayBuffer(file)
  }

  const handleExcelDownload = () => {
    try {
      const worksheet = XLSX.utils.json_to_sheet(gstr1Data.map(row => ({
        'GSTIN (Master)': row.gstinMaster,
        'GSTIN (Customer)': row.gstinCustomer,
        'Place of Supply': row.placeOfSupply,
        'Invoice Type': row.invoiceType,
        'Invoice No.': row.invoiceNo,
        'Invoice Date': formatDateForJson(row.invoiceDate),
        'Invoice Value': row.invoiceValue,
        'Taxable Value': row.taxableValue,
        'Rate': row.rate,
        'IGST': row.igst,
        'CGST': row.cgst,
        'SGST': row.sgst,
        'Cess': row.cess,
        'HSN': row.hsn,
        'UQC': row.uqc,
        'Quantity': row.quantity,
        'Reverse Charge': row.reverseCharge
      })))

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'GSTR1 Data')
      XLSX.writeFile(workbook, 'GSTR1_Details.xlsx')
      toast.success('Excel file downloaded successfully')
    } catch (error) {
      console.error('Error downloading Excel file:', error)
      toast.error('Error downloading Excel file')
    }
  }

  const handleTemplateDownload = () => {
    try {
      // Create template data with comprehensive examples
      const templateData = [
        // B2B Regular Transactions
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '30AACCE4248H1Z1',
          'Place of Supply': '30-Goa',
          'Invoice Type': 'Regular (B2B/B2C)',
          'Invoice No.': 'INV-001',
          'Invoice Date': '23-05-2025',
          'Invoice Value': 11800,
          'Taxable Value': 10000,
          'Rate': 18,
          'IGST': 1800,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '24AACCE4248H1ZU',
          'Place of Supply': '24-Gujarat',
          'Invoice Type': 'Regular (B2B/B2C)',
          'Invoice No.': 'INV-002',
          'Invoice Date': '24-05-2025',
          'Invoice Value': 5900,
          'Taxable Value': 5000,
          'Rate': 18,
          'IGST': 0,
          'CGST': 450,
          'SGST': 450,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        // B2CL Large B2C Transactions
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '06AACCE4248H1ZS',
          'Place of Supply': '06-Haryana',
          'Invoice Type': 'Regular (B2B/B2C)',
          'Invoice No.': 'INV-003',
          'Invoice Date': '25-05-2025',
          'Invoice Value': 23600,
          'Taxable Value': 20000,
          'Rate': 18,
          'IGST': 3600,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        // B2CS Small B2C Transactions
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '',
          'Place of Supply': '07-Delhi',
          'Invoice Type': 'Regular (B2B/B2C)',
          'Invoice No.': 'INV-004',
          'Invoice Date': '26-05-2025',
          'Invoice Value': 1180,
          'Taxable Value': 1000,
          'Rate': 18,
          'IGST': 0,
          'CGST': 90,
          'SGST': 90,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        // Export Transactions
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '',
          'Place of Supply': '96-Other Territory',
          'Invoice Type': 'Export Without payment of tax',
          'Invoice No.': 'EXP-001',
          'Invoice Date': '27-05-2025',
          'Invoice Value': 2000,
          'Taxable Value': 2000,
          'Rate': 0,
          'IGST': 0,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '',
          'Place of Supply': '96-Other Territory',
          'Invoice Type': 'Export with payment of tax',
          'Invoice No.': 'EXP-002',
          'Invoice Date': '28-05-2025',
          'Invoice Value': 2360,
          'Taxable Value': 2000,
          'Rate': 18,
          'IGST': 360,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        // SEZ Transactions
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '',
          'Place of Supply': '96-Other Territory',
          'Invoice Type': 'SEZ supply without payment of Tax',
          'Invoice No.': 'SEZ-001',
          'Invoice Date': '29-05-2025',
          'Invoice Value': 2000,
          'Taxable Value': 2000,
          'Rate': 0,
          'IGST': 0,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '',
          'Place of Supply': '96-Other Territory',
          'Invoice Type': 'SEZ supply with payment of Tax',
          'Invoice No.': 'SEZ-002',
          'Invoice Date': '30-05-2025',
          'Invoice Value': 2360,
          'Taxable Value': 2000,
          'Rate': 18,
          'IGST': 360,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        // Nil-rated and Exempt Transactions
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '02AACCE4248H1Z0',
          'Place of Supply': '02-Himachal Pradesh',
          'Invoice Type': 'Exempt',
          'Invoice No.': 'NIL-001',
          'Invoice Date': '31-05-2025',
          'Invoice Value': 1000,
          'Taxable Value': 1000,
          'Rate': 0,
          'IGST': 0,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '',
          'Place of Supply': '07-Delhi',
          'Invoice Type': 'Non-GST Supply',
          'Invoice No.': 'NIL-002',
          'Invoice Date': '01-06-2025',
          'Invoice Value': 1000,
          'Taxable Value': 1000,
          'Rate': 0,
          'IGST': 0,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        // Credit Notes (Negative Invoices)
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '30AACCE4248H1Z1',
          'Place of Supply': '30-Goa',
          'Invoice Type': 'Regular (B2B/B2C)',
          'Invoice No.': 'CN-001',
          'Invoice Date': '02-06-2025',
          'Invoice Value': -1180,
          'Taxable Value': -1000,
          'Rate': 18,
          'IGST': -180,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '',
          'Place of Supply': '07-Delhi',
          'Invoice Type': 'Regular (B2B/B2C)',
          'Invoice No.': 'CN-002',
          'Invoice Date': '03-06-2025',
          'Invoice Value': -1180,
          'Taxable Value': -1000,
          'Rate': 18,
          'IGST': 0,
          'CGST': -90,
          'SGST': -90,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        // Different Tax Rates Examples
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '30AACCE4248H1Z1',
          'Place of Supply': '30-Goa',
          'Invoice Type': 'Regular (B2B/B2C)',
          'Invoice No.': 'RATE-001',
          'Invoice Date': '04-06-2025',
          'Invoice Value': 500,
          'Taxable Value': 500,
          'Rate': 5,
          'IGST': 25,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '30AACCE4248H1Z1',
          'Place of Supply': '30-Goa',
          'Invoice Type': 'Regular (B2B/B2C)',
          'Invoice No.': 'RATE-002',
          'Invoice Date': '05-06-2025',
          'Invoice Value': 1280,
          'Taxable Value': 1000,
          'Rate': 12,
          'IGST': 120,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '30AACCE4248H1Z1',
          'Place of Supply': '30-Goa',
          'Invoice Type': 'Regular (B2B/B2C)',
          'Invoice No.': 'RATE-003',
          'Invoice Date': '06-06-2025',
          'Invoice Value': 1280,
          'Taxable Value': 1000,
          'Rate': 28,
          'IGST': 280,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'N'
        },
        // Reverse Charge Example
        {
          'GSTIN (Master)': '07AACCE4248H1ZQ',
          'GSTIN (Customer)': '30AACCE4248H1Z1',
          'Place of Supply': '30-Goa',
          'Invoice Type': 'Regular (B2B/B2C)',
          'Invoice No.': 'RC-001',
          'Invoice Date': '07-06-2025',
          'Invoice Value': 1000,
          'Taxable Value': 1000,
          'Rate': 18,
          'IGST': 0,
          'CGST': 0,
          'SGST': 0,
          'Cess': 0,
          'HSN': '998821',
          'UQC': 'NA',
          'Quantity': 1,
          'Reverse Charge': 'Y'
        }
      ]

      // Create worksheets for dropdown options
      const reverseChargeSheet = XLSX.utils.json_to_sheet(
        reverseChargeOptions.map(option => ({ 'Reverse Charge': option.value }))
      )

      const invoiceTypeSheet = XLSX.utils.json_to_sheet(
        invoiceTypeOptions.map(option => ({ 'Invoice Type': option.value }))
      )

      const uqcSheet = XLSX.utils.json_to_sheet(
        uqcOptions.map(option => ({ 'UQC': option.value }))
      )

      const placeOfSupplySheet = XLSX.utils.json_to_sheet(
        placeOfSupplyOptions.map(option => ({ 'Place of Supply': option.label }))
      )

      // Create main template worksheet
      const worksheet = XLSX.utils.json_to_sheet(templateData)

      // Add dropdown options as helper rows at the top of the template
      const dropdownOptions = [
        {
          'GSTIN (Master)': 'DROPDOWN OPTIONS - Copy these values:',
          'GSTIN (Customer)': '',
          'Place of Supply': '01,02,03,04,05,06,07,08,09,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,96',
          'Invoice Type': 'Regular,Export Without payment of tax,Export with payment of tax,SEZ supply without payment of Tax,SEZ supply with payment of Tax,Exempt,Non-GST Supply',
          'Invoice No.': '',
          'Invoice Date': '',
          'Invoice Value': '',
          'Taxable Value': '',
          'Rate': '',
          'IGST': '',
          'CGST': '',
          'SGST': '',
          'Cess': '',
          'HSN': '',
          'UQC': 'NA,KGS,LTR,MTR,NOS,PCS,SET,TON,YRD',
          'Quantity': '',
          'Reverse Charge': 'N,Y'
        }
      ]

      // Combine dropdown options with template data
      const finalTemplateData = [...dropdownOptions, ...templateData]

      // Recreate worksheet with dropdown options
      const finalWorksheet = XLSX.utils.json_to_sheet(finalTemplateData)

      // Add formatting to highlight dropdown options row
      const range = XLSX.utils.decode_range(finalWorksheet['!ref'])
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col })
        if (!finalWorksheet[cellAddress]) continue

        finalWorksheet[cellAddress].s = {
          fill: { fgColor: { rgb: 'FFFF00' } }, // Yellow background
          font: { bold: true, color: { rgb: 'FF0000' } } // Bold red text
        }
      }

      // Add data validation comments
      const comments = [
        'GSTIN (Master): Enter your GSTIN number',
        'GSTIN (Customer): Enter customer GSTIN number (Optional for B2CS, Export, SEZ, Nil-rated)',
        'Place of Supply: Copy from yellow row - Use 96 for Export/SEZ (see dropdown options in row 1)',
        'Invoice Type: Copy from yellow row - Required for all transactions (see dropdown options in row 1)',
        'Invoice No.: Enter invoice number',
        'Invoice Date: Enter date in DD-MM-YYYY format (e.g., 23-05-2025)',
        'Invoice Value: Enter total invoice value (negative for credit notes)',
        'Taxable Value: Enter taxable amount (negative for credit notes)',
        'Rate: Enter tax rate as percentage (0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, 28, or 40)',
        'IGST: Enter IGST amount (auto-calculated for inter-state, 0 for Export without payment)',
        'CGST: Enter CGST amount (auto-calculated for intra-state)',
        'SGST: Enter SGST amount (auto-calculated for intra-state)',
        'Cess: Enter cess amount (Optional)',
        'HSN: Enter HSN code',
        'UQC: Copy from yellow row (see dropdown options in row 1)',
        'Quantity: Enter quantity (default: 0)',
        'Reverse Charge: Copy from yellow row (see dropdown options in row 1)',
        '',
        'EXAMPLES INCLUDED:',
        '- B2B Regular transactions (inter-state and intra-state)',
        '- B2CL Large B2C transactions',
        '- B2CS Small B2C transactions',
        '- Export transactions (with and without payment)',
        '- SEZ transactions (with and without payment)',
        '- Nil-rated and Exempt transactions',
        '- Credit Notes (negative invoices)',
        '- Different tax rates (5%, 12%, 18%, 28%)',
        '- Reverse Charge transactions',
        '',
        'DROPDOWN OPTIONS (Row 1 - Yellow Highlighted):',
        '- Row 1 contains all valid options for Invoice Type, Reverse Charge, UQC, and Place of Supply',
        '- Copy values from the yellow row to ensure correct data entry',
        '- Prevents data entry errors and ensures consistency'
      ]

      // Create workbook with multiple sheets
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, finalWorksheet, 'GSTR1 Template')
      XLSX.utils.book_append_sheet(workbook, reverseChargeSheet, 'ReverseCharge')
      XLSX.utils.book_append_sheet(workbook, invoiceTypeSheet, 'InvoiceType')
      XLSX.utils.book_append_sheet(workbook, uqcSheet, 'UQC')
      XLSX.utils.book_append_sheet(workbook, placeOfSupplySheet, 'PlaceOfSupply')

      XLSX.writeFile(workbook, 'GSTR1_Complete_Template_With_Examples.xlsx')
      toast.success('Complete template with dropdown options and examples downloaded successfully!')
    } catch (error) {
      console.error('Error downloading template:', error)
      toast.error('Error downloading template')
    }
  }

  const clearAllData = () => {
    if (window.confirm('Are you sure you want to clear all data?')) {
      setGstr1Data([])
      setStorageItem(getStorageKey(), [])
      setNewRow({
        gstinMaster: activeClient?.gstinRegular || '',
        gstinCustomer: '',
        invoiceNo: '',
        invoiceDate: '',
        invoiceValue: '',
        placeOfSupply: '',
        reverseCharge: 'N',
        invoiceType: '',
        rate: '',
        taxableValue: '',
        igst: '0.00',
        cgst: '0.00',
        sgst: '0.00',
        cess: '0.00',
        hsn: '',
        uqc: '',
        quantity: '0'
      })
      toast.success('All data cleared')
    }
  }

  const deleteRow = (id) => {
    setGstr1Data(gstr1Data.filter(row => row.id !== id))
    toast.success('Row deleted successfully')
  }

  // Manual entry functions
  const handleAddNew = () => {
    setIsAdding(true)
    setEditingId(null)
    setNewRow({
      gstinMaster: activeClient?.gstinRegular || '',
      gstinCustomer: '',
      invoiceNo: '',
      invoiceDate: '',
      invoiceValue: '',
      placeOfSupply: '',
      reverseCharge: 'N',
      invoiceType: '',
      rate: '',
      taxableValue: '',
      igst: '0.00',
      cgst: '0.00',
      sgst: '0.00',
      cess: '0.00',
      hsn: '',
      uqc: '',
      quantity: '0'
    })
  }

  const handleSaveRow = () => {
    // Validate required fields (all fields except GSTIN Customer and Cess)
    if (!newRow.gstinMaster || !newRow.invoiceNo || !newRow.invoiceDate ||
      newRow.invoiceValue === '' || newRow.invoiceValue === null || newRow.invoiceValue === undefined ||
      !newRow.placeOfSupply || !newRow.reverseCharge ||
      newRow.rate === '' || newRow.rate === null || newRow.rate === undefined ||
      newRow.taxableValue === '' || newRow.taxableValue === null || newRow.taxableValue === undefined ||
      !newRow.hsn || !newRow.uqc || !newRow.invoiceType ||
      newRow.quantity === '' || newRow.quantity === null || newRow.quantity === undefined) {

      // More specific error message to help identify the issue
      let missingFields = []
      if (!newRow.gstinMaster) missingFields.push('GSTIN (Master)')
      if (!newRow.invoiceNo) missingFields.push('Invoice No')
      if (!newRow.invoiceDate) missingFields.push('Invoice Date')
      if (newRow.invoiceValue === '' || newRow.invoiceValue === null || newRow.invoiceValue === undefined) missingFields.push('Invoice Value')
      if (!newRow.placeOfSupply) missingFields.push('Place of Supply')
      if (!newRow.reverseCharge) missingFields.push('Reverse Charge')
      if (newRow.rate === '' || newRow.rate === null || newRow.rate === undefined) missingFields.push('Rate')
      if (newRow.taxableValue === '' || newRow.taxableValue === null || newRow.taxableValue === undefined) missingFields.push('Taxable Value')
      if (!newRow.hsn) missingFields.push('HSN')
      if (!newRow.uqc) missingFields.push('UQC')
      if (!newRow.invoiceType) missingFields.push('Invoice Type')
      if (newRow.quantity === '' || newRow.quantity === null || newRow.quantity === undefined) missingFields.push('Quantity')

      toast.error(`Please fill in: ${missingFields.join(', ')}`)
      return
    }

    // Validate date format (DD-MM-YYYY)
    if (!/^\d{2}-\d{2}-\d{4}$/.test(newRow.invoiceDate)) {
      toast.error('Invoice Date must be in DD-MM-YYYY format (e.g., 23-05-2025)')
      return
    }

    // Validate if it's a valid date
    const [day, month, year] = newRow.invoiceDate.split('-')
    const date = new Date(year, month - 1, day)
    if (date.getDate() != day || date.getMonth() != month - 1 || date.getFullYear() != year) {
      toast.error('Invoice Date is not a valid date')
      return
    }

    // Validate Invoice Type for all transactions
    const isB2B = newRow.gstinCustomer && newRow.gstinCustomer.trim() !== ''

    // Validate Tax Rate (must be 0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, 28, or 40) - Skip for tax-exempt invoice types
    const isTaxExempt = isTaxExemptInvoiceType(newRow.invoiceType)
    const rate = parseFloat(newRow.rate) || 0

    // Special validation for export/SEZ with payment - rate cannot be 0
    if (newRow.invoiceType === 'Export with payment of tax' || newRow.invoiceType === 'SEZ supply with payment of Tax') {
      if (rate === 0) {
        toast.error('Tax Rate cannot be 0 for "Export with payment of tax" or "SEZ supply with payment of Tax"')
        return
      }
    }

    if (!isTaxExempt) {
      const validRates = [0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, 28, 40]
      if (!validRates.includes(rate)) {
        toast.error(`Tax Rate must be one of: 0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, 28, or 40. Current value: ${rate}`)
        return
      }
    }

    // Validate tax calculation
    const gstinMasterFirstTwo = newRow.gstinMaster.substring(0, 2)
    const posEnum = getPosEnum(newRow.placeOfSupply)
    const isIntraState = gstinMasterFirstTwo === posEnum
    const taxableValue = parseFloat(newRow.taxableValue) || 0
    const enteredIgst = parseFloat(newRow.igst) || 0
    const enteredCgst = parseFloat(newRow.cgst) || 0
    const enteredSgst = parseFloat(newRow.sgst) || 0

    const taxAmount = (taxableValue * rate) / 100
    const calculatedIgst = isIntraState ? 0 : taxAmount
    const calculatedCgst = isIntraState ? taxAmount / 2 : 0
    const calculatedSgst = isIntraState ? taxAmount / 2 : 0

    // Round to 2 decimal places for comparison
    const roundedEnteredIgst = Math.round(enteredIgst * 100) / 100
    const roundedEnteredCgst = Math.round(enteredCgst * 100) / 100
    const roundedEnteredSgst = Math.round(enteredSgst * 100) / 100
    const roundedCalculatedIgst = Math.round(calculatedIgst * 100) / 100
    const roundedCalculatedCgst = Math.round(calculatedCgst * 100) / 100
    const roundedCalculatedSgst = Math.round(calculatedSgst * 100) / 100

    if (roundedEnteredIgst !== roundedCalculatedIgst) {
      toast.error(`IGST calculation mismatch. Expected: ${roundedCalculatedIgst.toFixed(2)}, Entered: ${roundedEnteredIgst.toFixed(2)}`)
      return
    }
    if (roundedEnteredCgst !== roundedCalculatedCgst) {
      toast.error(`CGST calculation mismatch. Expected: ${roundedCalculatedCgst.toFixed(2)}, Entered: ${roundedEnteredCgst.toFixed(2)}`)
      return
    }
    if (roundedEnteredSgst !== roundedCalculatedSgst) {
      toast.error(`SGST calculation mismatch. Expected: ${roundedCalculatedSgst.toFixed(2)}, Entered: ${roundedEnteredSgst.toFixed(2)}`)
      return
    }

    // Auto-correct UQC and Quantity for service HSN codes
    let finalUqc = newRow.uqc
    let finalQuantity = parseFloat(newRow.quantity) || 0

    if (isHsnService(newRow.hsn)) {
      finalUqc = 'NA'
      finalQuantity = 0
    }

    // Fixed type value as "OE"
    const type = 'OE'

    const rowData = {
      ...newRow,
      id: editingId || Date.now(),
      invoiceValue: parseFloat(newRow.invoiceValue) || 0,
      rate: rate,
      taxableValue: taxableValue,
      igst: roundedCalculatedIgst,
      cgst: roundedCalculatedCgst,
      sgst: roundedCalculatedSgst,
      cess: parseFloat(newRow.cess) || 0,
      uqc: finalUqc,
      quantity: finalQuantity,
      type: type
    }

    if (editingId) {
      const updatedData = gstr1Data.map(row => row.id === editingId ? rowData : row)
      setGstr1Data(updatedData)
      toast.success('Row updated successfully')
    } else {
      const updatedData = [...gstr1Data, rowData]
      setGstr1Data(updatedData)
      toast.success('Row added successfully')
    }

    setIsAdding(false)
    setEditingId(null)
    setNewRow({
      gstinMaster: activeClient?.gstinRegular || '',
      gstinCustomer: '',
      invoiceNo: '',
      invoiceDate: '',
      invoiceValue: '',
      placeOfSupply: '',
      reverseCharge: 'N',
      invoiceType: '',
      rate: '',
      taxableValue: '',
      igst: '0.00',
      cgst: '0.00',
      sgst: '0.00',
      cess: '0.00',
      hsn: '',
      uqc: '',
      quantity: '0'
    })
  }

  const handleEditRow = (row) => {
    setEditingId(row.id)
    setIsAdding(true)

    // Auto-correct UQC and Quantity for service HSN codes
    let uqc = row.uqc
    let quantity = row.quantity.toString()

    if (isHsnService(row.hsn)) {
      uqc = 'NA'
      quantity = '0'
    }

    setNewRow({
      gstinMaster: row.gstinMaster,
      gstinCustomer: row.gstinCustomer,
      invoiceNo: row.invoiceNo,
      invoiceDate: row.invoiceDate,
      invoiceValue: row.invoiceValue.toString(),
      placeOfSupply: row.placeOfSupply,
      reverseCharge: row.reverseCharge,
      invoiceType: row.invoiceType,
      rate: row.rate.toString(),
      taxableValue: row.taxableValue.toString(),
      igst: row.igst.toString(),
      cgst: row.cgst.toString(),
      sgst: row.sgst.toString(),
      cess: row.cess.toString(),
      hsn: row.hsn,
      uqc: uqc,
      quantity: quantity
    })
  }

  const handleCancelEdit = () => {
    setIsAdding(false)
    setEditingId(null)
    setNewRow({
      gstinMaster: activeClient?.gstinRegular || '',
      gstinCustomer: '',
      invoiceNo: '',
      invoiceDate: '',
      invoiceValue: '',
      placeOfSupply: '',
      reverseCharge: 'N',
      invoiceType: '',
      rate: '',
      taxableValue: '',
      igst: '0.00',
      cgst: '0.00',
      sgst: '0.00',
      cess: '0.00',
      hsn: '',
      uqc: '',
      quantity: '0'
    })
  }

  // Auto-calculate taxes when rate or taxable value changes
  const calculateTaxes = (rate, taxableValue, gstinMaster, placeOfSupply, invoiceType) => {
    if (!rate || !taxableValue || !gstinMaster || !placeOfSupply) {
      return { igst: '0.00', cgst: '0.00', sgst: '0.00' }
    }

    // For export without payment, tax should be 0
    if (invoiceType === 'Export Without payment of tax') {
      return { igst: '0.00', cgst: '0.00', sgst: '0.00' }
    }

    const gstinMasterFirstTwo = gstinMaster.substring(0, 2)
    const posEnum = getPosEnum(placeOfSupply)
    const isIntraState = gstinMasterFirstTwo === posEnum

    const taxAmount = (parseFloat(taxableValue) * parseFloat(rate)) / 100

    if (isIntraState) {
      // Intra state: CGST & SGST (half of rate each)
      return {
        igst: '0.00',
        cgst: (taxAmount / 2).toFixed(2),
        sgst: (taxAmount / 2).toFixed(2)
      }
    } else {
      // Inter state: IGST (full rate)
      return {
        igst: taxAmount.toFixed(2),
        cgst: '0.00',
        sgst: '0.00'
      }
    }
  }

  // Get unique GSTINs for summary dropdown
  const getUniqueGstins = () => {
    const gstins = [...new Set(gstr1Data.map(row => row.gstinMaster).filter(gstin => gstin && gstin.trim() !== ''))]
    return ['All', ...gstins.sort()]
  }

  // Handle section toggle
  const handleSectionToggle = (section, checked) => {
    if (section === 'all') {
      setSelectedSections({
        b2b: checked,
        b2cl: checked,
        b2cs: checked,
        cdnr: checked,
        cdnur: checked,
        hsn: checked,
        doc_issue: checked,
        exp: checked,
        sezwp: checked,
        sezwop: checked,
        nil: checked,
        all: checked
      })
    } else {
      const newSections = { ...selectedSections, [section]: checked }
      // If all individual sections are checked, check "all"
      const individualSections = ['b2b', 'b2cl', 'b2cs', 'cdnr', 'cdnur', 'hsn', 'doc_issue', 'exp', 'sezwp', 'sezwop', 'nil']
      const allIndividualChecked = individualSections.every(s => newSections[s])
      newSections.all = allIndividualChecked
      setSelectedSections(newSections)
    }
  }

  // Get count of selected sections
  const getSelectedSectionsCount = () => {
    if (selectedSections.all) return 'All'
    const individualSections = ['b2b', 'b2cl', 'b2cs', 'cdnr', 'cdnur', 'hsn', 'doc_issue', 'exp', 'sezwp', 'sezwop', 'nil']
    const count = individualSections.filter(s => selectedSections[s]).length
    return count
  }

  // Navigation confirmation functions
  const handleNavigationAttempt = (path) => {
    // Check if there's any data that would be lost
    const hasData = gstr1Data.length > 0

    if (hasData) {
      setPendingNavigation(path)
      setShowConfirmDialog(true)
    } else {
      navigate(path)
    }
  }

  const handleConfirmNavigation = () => {
    if (pendingNavigation) {
      // Clear GSTR1 data before navigation
      setGstr1Data([])
      setStorageItem(getStorageKey(), [])
      navigate(pendingNavigation)
    }
    setShowConfirmDialog(false)
    setPendingNavigation(null)
  }

  const handleCancelNavigation = () => {
    setShowConfirmDialog(false)
    setPendingNavigation(null)
  }

  // JSON Payload Summary - Directly linked to actual JSON generator
  const getJsonPayloadSummary = () => {
    if (!selectedGstinForSummary) return null

    const gstinData = selectedGstinForSummary === 'All'
      ? gstr1Data
      : gstr1Data.filter(row => row.gstinMaster === selectedGstinForSummary)
    if (gstinData.length === 0) return null

    // Generate JSON payload
    const jsonData = generateUnifiedJson(selectedGstinForSummary, gstinData, selectedSections)
    if (!jsonData) return null

    const getEmptyTotals = () => ({ count: 0, taxableValue: 0, igst: 0, cgst: 0, sgst: 0, cess: 0 })

    const summary = {
      b2b: getEmptyTotals(),
      b2cl: getEmptyTotals(),
      b2cs: getEmptyTotals(),
      exp: getEmptyTotals(),
      sezwp: getEmptyTotals(),
      sezwop: getEmptyTotals(),
      nil: getEmptyTotals(),
      cdnr: getEmptyTotals(),
      cdnur: getEmptyTotals(),
      hsn: getEmptyTotals(),
      doc_issue: getEmptyTotals(),
      combined: getEmptyTotals(),
      difference: getEmptyTotals(),
      docDetails: []
    }

    if (jsonData.b2b) {
      jsonData.b2b.forEach(recipient => {
        recipient.inv.forEach(inv => {
          summary.b2b.count++
          inv.itms.forEach(item => {
            summary.b2b.taxableValue += item.itm_det.txval || 0
            summary.b2b.igst += item.itm_det.iamt || 0
            summary.b2b.cgst += item.itm_det.camt || 0
            summary.b2b.sgst += item.itm_det.samt || 0
            summary.b2b.cess += item.itm_det.csamt || 0
          })
        })
      })
    }

    if (jsonData.b2cl) {
      jsonData.b2cl.forEach(pos => {
        pos.inv.forEach(inv => {
          summary.b2cl.count++
          inv.itms.forEach(item => {
            summary.b2cl.taxableValue += item.itm_det.txval || 0
            summary.b2cl.igst += item.itm_det.iamt || 0
            summary.b2cl.cgst += item.itm_det.camt || 0
            summary.b2cl.sgst += item.itm_det.samt || 0
            summary.b2cl.cess += item.itm_det.csamt || 0
          })
        })
      })
    }

    if (jsonData.b2cs) {
      jsonData.b2cs.forEach(item => {
        summary.b2cs.count++
        summary.b2cs.taxableValue += item.txval || 0
        summary.b2cs.igst += item.iamt || 0
        summary.b2cs.cgst += item.camt || 0
        summary.b2cs.sgst += item.samt || 0
        summary.b2cs.cess += item.csamt || 0
      })
    }

    if (jsonData.exp) {
      jsonData.exp.forEach(type => {
        type.inv.forEach(inv => {
          summary.exp.count++
          inv.itms.forEach(item => {
            summary.exp.taxableValue += item.txval || 0
            summary.exp.igst += item.iamt || 0
            summary.exp.cess += item.csamt || 0
          })
        })
      })
    }

    if (jsonData.sezwp) {
      jsonData.sezwp.forEach(inv => {
        summary.sezwp.count++
        inv.itms.forEach(item => {
          summary.sezwp.taxableValue += item.txval || 0
          summary.sezwp.igst += item.iamt || 0
          summary.sezwp.cess += item.csamt || 0
        })
      })
    }

    if (jsonData.sezwop) {
      jsonData.sezwop.forEach(inv => {
        summary.sezwop.count++
        inv.itms.forEach(item => {
          summary.sezwop.taxableValue += item.txval || 0
          summary.sezwop.igst += item.iamt || 0
          summary.sezwop.cess += item.csamt || 0
        })
      })
    }

    if (jsonData.nil && jsonData.nil.inv) {
      jsonData.nil.inv.forEach(inv => {
        summary.nil.count++
        summary.nil.taxableValue += (inv.expt_amt || 0) + (inv.nil_amt || 0) + (inv.ngsup_amt || 0)
      })
    }

    if (jsonData.cdnr) {
      jsonData.cdnr.forEach(recipient => {
        recipient.nt.forEach(nt => {
          summary.cdnr.count++
          nt.itms.forEach(item => {
            summary.cdnr.taxableValue += item.itm_det.txval || 0
            summary.cdnr.igst += item.itm_det.iamt || 0
            summary.cdnr.cgst += item.itm_det.camt || 0
            summary.cdnr.sgst += item.itm_det.samt || 0
            summary.cdnr.cess += item.itm_det.csamt || 0
          })
        })
      })
    }

    if (jsonData.cdnur) {
      jsonData.cdnur.forEach(nt => {
        summary.cdnur.count++
        nt.itms.forEach(item => {
          summary.cdnur.taxableValue += item.itm_det.txval || 0
          summary.cdnur.igst += item.itm_det.iamt || 0
          summary.cdnur.cgst += item.itm_det.camt || 0
          summary.cdnur.sgst += item.itm_det.samt || 0
          summary.cdnur.cess += item.itm_det.csamt || 0
        })
      })
    }

    if (jsonData.hsn) {
      const allHsn = [...(jsonData.hsn.hsn_b2b || []), ...(jsonData.hsn.hsn_b2c || [])]
      allHsn.forEach(hsn => {
        summary.hsn.count++
        summary.hsn.taxableValue += hsn.txval || 0
        summary.hsn.igst += hsn.iamt || 0
        summary.hsn.cgst += hsn.camt || 0
        summary.hsn.sgst += hsn.samt || 0
        summary.hsn.cess += hsn.csamt || 0
      })
    }

    if (jsonData.doc_issue && jsonData.doc_issue.doc_det) {
      jsonData.doc_issue.doc_det.forEach(det => {
        summary.doc_issue.count += det.docs.reduce((acc, doc) => acc + (doc.net_issue || 0), 0)
        summary.docDetails.push({
          type: det.doc_typ,
          docs: det.docs.map(d => `From ${d.from} to ${d.to} (Total: ${d.net_issue})`).join(', ')
        })
      })
    }

    // Combined net totals
    summary.combined = {
      taxableValue: summary.b2b.taxableValue + summary.b2cl.taxableValue + summary.b2cs.taxableValue + summary.exp.taxableValue + summary.sezwp.taxableValue + summary.sezwop.taxableValue + summary.nil.taxableValue - summary.cdnr.taxableValue - summary.cdnur.taxableValue,
      igst: summary.b2b.igst + summary.b2cl.igst + summary.b2cs.igst + summary.exp.igst + summary.sezwp.igst + summary.sezwop.igst - summary.cdnr.igst - summary.cdnur.igst,
      cgst: summary.b2b.cgst + summary.b2cl.cgst + summary.b2cs.cgst + summary.exp.cgst + summary.sezwp.cgst + summary.sezwop.cgst - summary.cdnr.cgst - summary.cdnur.cgst,
      sgst: summary.b2b.sgst + summary.b2cl.sgst + summary.b2cs.sgst + summary.exp.sgst + summary.sezwp.sgst + summary.sezwop.sgst - summary.cdnr.sgst - summary.cdnur.sgst,
      cess: summary.b2b.cess + summary.b2cl.cess + summary.b2cs.cess + summary.exp.cess + summary.sezwp.cess + summary.sezwop.cess - summary.cdnr.cess - summary.cdnur.cess
    }

    summary.difference = {
      taxableValue: Math.round((summary.combined.taxableValue - summary.hsn.taxableValue) * 100) / 100,
      igst: Math.round((summary.combined.igst - summary.hsn.igst) * 100) / 100,
      cgst: Math.round((summary.combined.cgst - summary.hsn.cgst) * 100) / 100,
      sgst: Math.round((summary.combined.sgst - summary.hsn.sgst) * 100) / 100,
      cess: Math.round((summary.combined.cess - summary.hsn.cess) * 100) / 100
    }

    return summary
  }

  // Calculate summary data for selected GSTIN
  const getSummaryData = () => {
    if (!selectedGstinForSummary) return null

    // Handle "All" selection - use all data
    const gstinData = selectedGstinForSummary === 'All'
      ? gstr1Data
      : gstr1Data.filter(row => row.gstinMaster === selectedGstinForSummary)

    // Separate regular invoices and credit notes
    const regularInvoices = gstinData.filter(row => row.invoiceValue >= 0)
    const creditNotes = gstinData.filter(row => row.invoiceValue < 0)

    // Separate B2B and B2C transactions (regular invoices only, excluding tax-exempt, export, and nil-rated)
    const b2bTransactions = regularInvoices.filter(row =>
      row.gstinCustomer && row.gstinCustomer.trim() !== '' &&
      !isTaxExemptInvoiceType(row.invoiceType) && !isExportInvoiceType(row.invoiceType) && row.rate !== 0
    )
    const b2cTransactions = regularInvoices.filter(row =>
      (!row.gstinCustomer || row.gstinCustomer.trim() === '') &&
      !isTaxExemptInvoiceType(row.invoiceType) && !isExportInvoiceType(row.invoiceType) && row.rate !== 0
    )

    // Helper to calculate total value per invoice to properly check B2CL limit
    const getInvoiceTotals = (transactions) => {
      const totals = {};
      transactions.forEach(row => {
          if (!totals[row.invoiceNo]) {
              totals[row.invoiceNo] = 0;
          }
          const rowTotal = (parseFloat(row.taxableValue) || 0) + 
                           (parseFloat(row.igst) || 0) + 
                           (parseFloat(row.cgst) || 0) + 
                           (parseFloat(row.sgst) || 0) + 
                           (parseFloat(row.cess) || 0);
          totals[row.invoiceNo] += Math.abs(rowTotal);
      });
      return totals;
    };

    const b2cTotals = getInvoiceTotals(b2cTransactions);

    // Separate B2CL and B2CS (regular invoices only)
    const b2clTransactions = b2cTransactions.filter(row =>
      b2cTotals[row.invoiceNo] > 100000 && isInterStateTransaction(row.gstinMaster, row.placeOfSupply)
    )
    const b2csTransactions = b2cTransactions.filter(row =>
      b2cTotals[row.invoiceNo] <= 100000 || !isInterStateTransaction(row.gstinMaster, row.placeOfSupply)
    )

    // Separate credit notes by B2B and B2C
    const b2bCreditNotes = creditNotes.filter(row => row.gstinCustomer && row.gstinCustomer.trim() !== '')
    const b2cCreditNotes = creditNotes.filter(row => !row.gstinCustomer || row.gstinCustomer.trim() === '')

    const b2cCreditTotals = getInvoiceTotals(b2cCreditNotes);

    // Separate B2CL and B2CS credit notes
    const b2clCreditNotes = b2cCreditNotes.filter(row =>
      b2cCreditTotals[row.invoiceNo] > 100000 && isInterStateTransaction(row.gstinMaster, row.placeOfSupply)
    )
    const b2csCreditNotes = b2cCreditNotes.filter(row =>
      b2cCreditTotals[row.invoiceNo] <= 100000 || !isInterStateTransaction(row.gstinMaster, row.placeOfSupply)
    )

    // Calculate totals (including credit notes)
    const b2bTotal = b2bTransactions.reduce((sum, row) => sum + (parseFloat(row.invoiceValue) || 0), 0) +
      b2bCreditNotes.reduce((sum, row) => sum + (parseFloat(row.invoiceValue) || 0), 0)
    const b2clTotal = b2clTransactions.reduce((sum, row) => sum + (parseFloat(row.invoiceValue) || 0), 0) +
      b2clCreditNotes.reduce((sum, row) => sum + (parseFloat(row.invoiceValue) || 0), 0)
    const b2csTotal = b2csTransactions.reduce((sum, row) => sum + (parseFloat(row.invoiceValue) || 0), 0) +
      b2csCreditNotes.reduce((sum, row) => sum + (parseFloat(row.invoiceValue) || 0), 0)

    const totalInvoiceValue = gstinData.reduce((sum, row) => sum + (parseFloat(row.invoiceValue) || 0), 0)
    const totalTaxableValue = gstinData.reduce((sum, row) => sum + (parseFloat(row.taxableValue) || 0), 0)
    const totalIGST = gstinData.reduce((sum, row) => sum + (parseFloat(row.igst) || 0), 0)
    const totalCGST = gstinData.reduce((sum, row) => sum + (parseFloat(row.cgst) || 0), 0)
    const totalSGST = gstinData.reduce((sum, row) => sum + (parseFloat(row.sgst) || 0), 0)
    const totalCess = gstinData.reduce((sum, row) => sum + (parseFloat(row.cess) || 0), 0)

    // Get unique invoice count
    const uniqueInvoices = [...new Set(gstinData.map(row => row.invoiceNo).filter(inv => inv && inv.trim() !== ''))]

    // Get HSN summary
    const hsnSummary = {}
    gstinData.forEach(row => {
      const key = `${row.hsn}_${row.rate}`
      if (!hsnSummary[key]) {
        hsnSummary[key] = {
          hsn: row.hsn,
          rate: row.rate,
          quantity: 0,
          taxableValue: 0,
          igst: 0,
          cgst: 0,
          sgst: 0,
          cess: 0
        }
      }
      hsnSummary[key].quantity += (parseFloat(row.quantity) || 0)
      hsnSummary[key].taxableValue += (parseFloat(row.taxableValue) || 0)
      hsnSummary[key].igst += (parseFloat(row.igst) || 0)
      hsnSummary[key].cgst += (parseFloat(row.cgst) || 0)
      hsnSummary[key].sgst += (parseFloat(row.sgst) || 0)
      hsnSummary[key].cess += (parseFloat(row.cess) || 0)
    })

    // Group B2CS by rate and place of supply for summary (including credit notes)
    const b2csGrouped = {}
    const allB2csTransactions = [...b2csTransactions, ...b2csCreditNotes]
    allB2csTransactions.forEach(row => {
      const key = `${row.rate}_${row.placeOfSupply}`
      if (!b2csGrouped[key]) {
        b2csGrouped[key] = {
          pos: row.placeOfSupply,
          rt: row.rate,
          txval: 0,
          iamt: 0,
          camt: 0,
          samt: 0,
          csamt: 0
        }
      }
      // For B2CS, net the values (regular invoices + credit notes)
      // This will properly net positive and negative values
      b2csGrouped[key].txval += (parseFloat(row.taxableValue) || 0)
      b2csGrouped[key].iamt += (parseFloat(row.igst) || 0)
      b2csGrouped[key].camt += (parseFloat(row.cgst) || 0)
      b2csGrouped[key].samt += (parseFloat(row.sgst) || 0)
      b2csGrouped[key].csamt += (parseFloat(row.cess) || 0)
    })

    return {
      gstin: selectedGstinForSummary,
      totalRecords: gstinData.length,
      b2bCount: b2bTransactions.length,
      b2clCount: b2clTransactions.length,
      b2csCount: b2csTransactions.length + b2csCreditNotes.length,
      b2bTotal,
      b2clTotal,
      b2csTotal,
      totalInvoiceValue,
      totalTaxableValue,
      totalIGST,
      totalCGST,
      totalSGST,
      totalCess,
      uniqueInvoiceCount: uniqueInvoices.length,
      hsnSummary: Object.values(hsnSummary),
      b2bTransactions,
      b2bCreditNotes,
      b2clTransactions,
      b2clCreditNotes,
      b2csGrouped: Object.values(b2csGrouped)
    }
  }

  const validateData = (dataToValidate) => {
    const errors = []


    dataToValidate.forEach((row, index) => {
      const rowNum = index + 1
      const invNo = row.invoiceNo ? row.invoiceNo.toString().trim() : ''
      const desc = row.invoiceNo ? `Inv No: ${invNo}` : `Row ${rowNum}`

      // 1. GSTIN Master check
      if (!row.gstinMaster || row.gstinMaster.toString().trim() === '') {
        errors.push(`Row ${rowNum}: GSTIN (Master) is required`)
      } else if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/.test(row.gstinMaster.toString().trim())) {
        errors.push(`Row ${rowNum} (${desc}): GSTIN (Master) format is invalid`)
      }

      // 2. Invoice No. Validation
      if (!invNo) {
        errors.push(`Row ${rowNum}: Invoice No is required`)
      } else {
        if (invNo.length > 16) {
          errors.push(`Row ${rowNum} (${desc}): Invoice number cannot exceed 16 characters`)
        }
        if (!/^[a-zA-Z0-9\-/]+$/.test(invNo)) {
          errors.push(`Row ${rowNum} (${desc}): Invoice number contains invalid characters. Only alphanumeric, '/' and '-' are allowed.`)
        }
        

      }

      // 3. Invoice Date check
      if (!row.invoiceDate || row.invoiceDate.toString().trim() === '') {
        errors.push(`Row ${rowNum} (${desc}): Invoice Date is required`)
      }

      // 4. Place of Supply Validation
      const posCode = getPosEnum(row.placeOfSupply)
      const validPosCodes = placeOfSupplyOptions.map(opt => opt.value)
      if (!posCode || !validPosCodes.includes(posCode)) {
        errors.push(`Row ${rowNum} (${desc}): Place of Supply must be a valid selection`)
      }

      // 5. UQC and HSN Service validation
      if (!row.hsn || row.hsn.toString().trim() === '') {
        errors.push(`Row ${rowNum} (${desc}): HSN is required`)
      } else if (isHsnService(row.hsn)) {
        if (row.uqc !== 'NA') {
          errors.push(`Row ${rowNum} (${desc}): Service HSN '${row.hsn}' must have UQC 'NA-Not applicable'`)
        }
      }

      // 6. Tax Calculation validation (with Interstate and intra state)
      if (row.gstinMaster && posCode && validPosCodes.includes(posCode)) {
        const gstinFirstTwo = row.gstinMaster.substring(0, 2)
        const isIntraState = gstinFirstTwo === posCode
        const rate = parseFloat(row.rate) || 0
        const taxableValue = parseFloat(row.taxableValue) || 0
        const taxAmount = (taxableValue * rate) / 100

        let expectedIgst = 0
        let expectedCgst = 0
        let expectedSgst = 0

        if (row.invoiceType === 'Export Without payment of tax' || isTaxExemptInvoiceType(row.invoiceType)) {
          expectedIgst = 0
          expectedCgst = 0
          expectedSgst = 0
        } else if (isIntraState) {
          expectedCgst = Math.round((taxAmount / 2) * 100) / 100
          expectedSgst = Math.round((taxAmount / 2) * 100) / 100
        } else {
          expectedIgst = Math.round(taxAmount * 100) / 100
        }

        const enteredIgst = Math.round((parseFloat(row.igst) || 0) * 100) / 100
        const enteredCgst = Math.round((parseFloat(row.cgst) || 0) * 100) / 100
        const enteredSgst = Math.round((parseFloat(row.sgst) || 0) * 100) / 100

        if (Math.abs(enteredIgst - expectedIgst) > 0.05) {
          errors.push(`Row ${rowNum} (${desc}): IGST calculation mismatch. Expected: ${expectedIgst.toFixed(2)}, Entered: ${enteredIgst.toFixed(2)}`)
        }
        if (Math.abs(enteredCgst - expectedCgst) > 0.05) {
          errors.push(`Row ${rowNum} (${desc}): CGST calculation mismatch. Expected: ${expectedCgst.toFixed(2)}, Entered: ${enteredCgst.toFixed(2)}`)
        }
        if (Math.abs(enteredSgst - expectedSgst) > 0.05) {
          errors.push(`Row ${rowNum} (${desc}): SGST calculation mismatch. Expected: ${expectedSgst.toFixed(2)}, Entered: ${enteredSgst.toFixed(2)}`)
        }
      }
    })

    return errors
  }

  const generateIndividualReturn = async (gstinMaster) => {
    if (!gstinMaster) {
      toast.error('Please select a GSTIN for summary')
      return
    }

    // Run validation on the selected data
    const dataToValidate = gstinMaster === 'All'
      ? gstr1Data
      : gstr1Data.filter(row => row.gstinMaster === gstinMaster)

    const validationErrors = validateData(dataToValidate)
    if (validationErrors.length > 0) {
      clearErrors()
      addError('Please fix the following errors before preparing return:')
      validationErrors.forEach(err => addError(`• ${err}`))
      toast.error('Please fix the validation errors in the sidebar before preparing return.')
      return
    }

    try {
      // Check if File System Access API is supported
      if ('showDirectoryPicker' in window) {
        let directoryHandle
        try {
          // Show folder picker dialog
          directoryHandle = await window.showDirectoryPicker({
            mode: 'readwrite',
            startIn: 'downloads'
          })
        } catch (error) {
          if (error.name === 'AbortError') {
            toast.info('Folder selection cancelled')
            return
          }
          console.error('Error selecting folder:', error)
          toast.error('Error selecting folder. Using default download location.')
        }

        if (directoryHandle) {
          if (gstinMaster === 'All') {
            // Generate JSON for all GSTINs in selected folder
            const uniqueGstins = [...new Set(gstr1Data.map(row => row.gstinMaster).filter(gstin => gstin && gstin.trim() !== ''))]
            let successCount = 0
            let errorCount = 0

            for (const gstin of uniqueGstins) {
              const gstinData = gstr1Data.filter(row => row.gstinMaster === gstin)
              if (gstinData.length > 0) {
                try {
                  await generateJsonForGstinToFolder(gstin, gstinData, selectedSections, directoryHandle)
                  successCount++
                  // Add delay between downloads
                  await new Promise(resolve => setTimeout(resolve, 500))
                } catch (error) {
                  console.error(`Error generating JSON for ${gstin}:`, error)
                  errorCount++
                }
              }
            }

            const sectionsText = selectedSections.all ? 'all sections' : `${getSelectedSectionsCount()} sections`
            if (successCount > 0) {
              toast.success(`Generated ${successCount} JSON files in selected folder (${sectionsText})`)
            }
            if (errorCount > 0) {
              toast.error(`Failed to generate ${errorCount} JSON files`)
            }
          } else {
            // Generate JSON for single GSTIN in selected folder
            const gstinData = gstr1Data.filter(row => row.gstinMaster === gstinMaster)
            if (gstinData.length === 0) {
              toast.error('No data available for selected GSTIN')
              return
            }

            await generateJsonForGstinToFolder(gstinMaster, gstinData, selectedSections, directoryHandle)
            const sectionsText = selectedSections.all ? 'all sections' : `${getSelectedSectionsCount()} sections`
            toast.success(`GSTR1 JSON file saved to selected folder for ${gstinMaster} (${sectionsText})`)
          }
        }
      } else {
        // Fallback to traditional download for browsers that don't support File System Access API
        toast.info('Using default download location (folder selection not supported in this browser)')

        if (gstinMaster === 'All') {
          // Generate JSON for all GSTINs
          const uniqueGstins = [...new Set(gstr1Data.map(row => row.gstinMaster).filter(gstin => gstin && gstin.trim() !== ''))]
          let successCount = 0
          let errorCount = 0

          for (const gstin of uniqueGstins) {
            const gstinData = gstr1Data.filter(row => row.gstinMaster === gstin)
            if (gstinData.length > 0) {
              try {
                generateJsonForGstin(gstin, gstinData, selectedSections)
                successCount++
                // Add delay between downloads
                await new Promise(resolve => setTimeout(resolve, 500))
              } catch (error) {
                console.error(`Error generating JSON for ${gstin}:`, error)
                errorCount++
              }
            }
          }

          const sectionsText = selectedSections.all ? 'all sections' : `${getSelectedSectionsCount()} sections`
          if (successCount > 0) {
            toast.success(`Generated ${successCount} JSON files for all GSTINs (${sectionsText})`)
          }
          if (errorCount > 0) {
            toast.error(`Failed to generate ${errorCount} JSON files`)
          }
        } else {
          // Generate JSON for single GSTIN
          const gstinData = gstr1Data.filter(row => row.gstinMaster === gstinMaster)
          if (gstinData.length === 0) {
            toast.error('No data available for selected GSTIN')
            return
          }

          generateJsonForGstin(gstinMaster, gstinData, selectedSections)
          const sectionsText = selectedSections.all ? 'all sections' : `${getSelectedSectionsCount()} sections`
          toast.success(`GSTR1 JSON file generated for ${gstinMaster} (${sectionsText})`)
        }
      }
    } catch (error) {
      console.error('Error generating individual return:', error)
      toast.error('Error generating individual return')
    }
  }

  // ============================================================================
  // UNIFIED JSON GENERATION SYSTEM
  // ============================================================================

  // Unified JSON generation function with consistent validation
  const generateUnifiedJson = (gstinMaster, gstinData, sections = null) => {
    return generateUnifiedJsonHelper(gstinMaster, gstinData, sections, selectedMonth, selectedYear)
  }

  // Helper function to generate JSON and save to selected folder
  const generateJsonForGstinToFolder = async (gstinMaster, gstinData, sections, directoryHandle) => {
    // Use unified JSON generation function
    const jsonData = generateUnifiedJson(gstinMaster, gstinData, sections)

    if (!jsonData) {
      throw new Error(`Failed to generate JSON for ${gstinMaster}`)
    }

    // Get current financial year and period
    const currentDate = new Date()
    const currentYear = currentDate.getFullYear()
    const currentMonth = currentDate.getMonth() + 1

    // Determine financial year
    let financialYear
    if (currentMonth >= 4) {
      financialYear = currentYear
    } else {
      financialYear = currentYear - 1
    }

    const fp = `${selectedMonth.toString().padStart(2, '0')}${selectedYear}`

    // Save JSON file to selected folder
    const jsonString = JSON.stringify(jsonData, null, 2)
    const fileName = `${gstinMaster}_GSTR1.json`

    try {
      const fileHandle = await directoryHandle.getFileHandle(fileName, { create: true })
      const writable = await fileHandle.createWritable()
      await writable.write(jsonString)
      await writable.close()
    } catch (error) {
      console.error(`Error saving file ${fileName}:`, error)
      throw error
    }
  }

  // Individual JSON generation function (downloads file)
  const generateJsonForGstin = (gstinMaster, gstinData, sections = null) => {
    // Use unified JSON generation function
    const jsonData = generateUnifiedJson(gstinMaster, gstinData, sections)

    if (!jsonData) {
      toast.error(`Failed to generate JSON for ${gstinMaster}`)
      return
    }

    // Download JSON file
    const jsonString = JSON.stringify(jsonData, null, 2)
    const fileName = `${gstinMaster}_GSTR1.json`
    const blob = new Blob([jsonString], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  // Bulk JSON generation function (generates for all GSTINs)
  const generateGstr1Json = () => {
    // Input validation
    if (!gstr1Data || !Array.isArray(gstr1Data) || gstr1Data.length === 0) {
      toast.error('No data available to generate return')
      return
    }

    // Run validation on all records
    const validationErrors = validateData(gstr1Data)
    if (validationErrors.length > 0) {
      clearErrors()
      addError('Please fix the following errors before preparing return:')
      validationErrors.forEach(err => addError(`• ${err}`))
      toast.error('Please fix the validation errors in the sidebar before preparing return.')
      return
    }

    try {
      // Group data by GSTIN Master
      const groupedByGstin = {}

      gstr1Data.forEach(row => {
        const gstinMaster = row.gstinMaster
        if (!groupedByGstin[gstinMaster]) {
          groupedByGstin[gstinMaster] = []
        }
        groupedByGstin[gstinMaster].push(row)
      })

      // Generate JSON for each GSTIN Master using unified function
      Object.keys(groupedByGstin).forEach(gstinMaster => {
        const gstinData = groupedByGstin[gstinMaster]

        // Use unified JSON generation function
        const jsonData = generateUnifiedJson(gstinMaster, gstinData, selectedSections)

        if (jsonData) {
          // Download JSON file
          const jsonString = JSON.stringify(jsonData, null, 2)
          const fileName = `${gstinMaster}_GSTR1.json`
          const blob = new Blob([jsonString], { type: 'application/json' })
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(url)
        }
      })

      toast.success(`GSTR1 JSON files generated for ${Object.keys(groupedByGstin).length} GSTIN(s)`)
    } catch (error) {
      console.error('Error generating GSTR1 JSON:', error)
      toast.error('Error generating GSTR1 JSON')
    }
  }

  // ============================================================================
  // UI COMPONENTS AND RENDERING
  // ============================================================================

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="flex items-center justify-between px-4 py-3">
          <div className="flex items-center space-x-4">
            <button
              onClick={() => navigate('/gst-dashboard/gstr7')}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            >
              <ArrowLeft className="w-6 h-6" />
            </button>
            <div className="flex items-center space-x-2">
              <Building2 className="w-8 h-8 text-purple-600" />
              <div>
                <h1 className="text-xl font-semibold text-gray-900">GST Return</h1>
                <p className="text-sm text-gray-500">GSTR1 - Sales Return</p>
              </div>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <button
              onClick={() => {
                setStorageItem(getStorageKey(), [])
                // keep preferences if desired, or remove generic ones if needed
                navigate('/')
              }}
              className="flex items-center text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-100 transition-colors"
            >
              <X className="w-4 h-4 mr-2" />
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="flex w-full">
        {/* Sidebar */}
        <GstSidebar
          onSidebarStateChange={(state) => setSidebarOpen(state.isOpen)}
          onNavigationAttempt={(path) => navigate(path)}
        />

        {/* Main Content */}
        <main className="flex-1 ml-64 w-full min-w-0">
          <div className="p-2 w-full max-w-none">
            {/* Page Title */}
            <div className="mb-2">
              <h2 className="text-xl font-bold text-gray-900 mb-1">
                GSTR1 - Sales Return
              </h2>
              <p className="text-gray-600 text-xs">
                Manage your GSTR1 sales return data for {selectedMonth}/{selectedYear}
              </p>
            </div>

            {/* Tab Navigation */}
            <div className="mb-4">
              <div className="bg-white p-1 rounded-lg shadow-sm border border-gray-200 w-fit">
                <nav className="flex space-x-1" aria-label="Tabs">
                  <button
                    onClick={() => setActiveTab('data-entry')}
                    className={`px-6 py-2 rounded-md font-medium text-sm transition-all duration-200 ${activeTab === 'data-entry'
                      ? 'bg-purple-600 text-white shadow-sm'
                      : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
                      }`}
                  >
                    Data Entry
                  </button>
                  <button
                    onClick={() => setActiveTab('summary')}
                    className={`px-6 py-2 rounded-md font-medium text-sm transition-all duration-200 ${activeTab === 'summary'
                      ? 'bg-purple-600 text-white shadow-sm'
                      : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
                      }`}
                  >
                    Summary
                  </button>
                </nav>
              </div>
            </div>

            {/* Year and Month Selection */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 mb-2">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Financial Year
                  </label>
                  <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                  >
                    {Array.from({ length: 10 }, (_, i) => {
                      const year = new Date().getFullYear() - i
                      return (
                        <option key={year} value={year.toString()}>
                          {year}
                        </option>
                      )
                    })}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Month
                  </label>
                  <select
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                  >
                    {Array.from({ length: selectedYear === currentYear.toString() ? currentMonth : 12 }, (_, i) => (
                      <option key={i + 1} value={(i + 1).toString()}>
                        {new Date(0, i).toLocaleString('default', { month: 'long' })}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Tab Content */}
            {activeTab === 'data-entry' && (
              <>

                {/* Action Buttons */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-2 mb-2">
                  <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3 mb-3">
                    <p className="text-sm text-yellow-800">
                      <strong>Important:</strong> For Excel upload, ensure dates are in DD-MM-YYYY format (e.g., 23-05-2025).
                      If Excel converts dates to numbers, the system will automatically convert them back to proper date format.
                    </p>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    <input
                      type="file"
                      id="excel-upload"
                      accept=".xlsx,.xls"
                      onChange={handleExcelUpload}
                      className="hidden"
                    />
                    <button
                      onClick={() => document.getElementById('excel-upload').click()}
                      className="px-3 py-1.5 bg-green-600 text-white rounded text-sm hover:bg-green-700 transition-colors"
                    >
                      Upload Excel
                    </button>
                    <button
                      onClick={handleTemplateDownload}
                      className="px-3 py-1.5 bg-green-600 text-white rounded text-sm hover:bg-green-700 transition-colors"
                    >
                      Download Template
                    </button>
                    <button
                      onClick={handleExcelDownload}
                      className="px-3 py-1.5 bg-orange-600 text-white rounded text-sm hover:bg-orange-700 transition-colors"
                    >
                      Download Excel
                    </button>
                    <button
                      onClick={clearAllData}
                      className="px-3 py-1.5 bg-red-600 text-white rounded text-sm hover:bg-red-700 transition-colors"
                    >
                      Clear All
                    </button>
                    <button
                      onClick={generateGstr1Json}
                      className="px-3 py-1.5 bg-purple-600 text-white rounded text-sm hover:bg-purple-700 transition-colors"
                    >
                      Prepare Return
                    </button>
                    <button
                      onClick={handleGridRowAdd}
                      className="px-3 py-1.5 bg-green-600 text-white rounded text-sm hover:bg-green-700 transition-colors"
                    >
                      Add New Row
                    </button>
                  </div>
                </div>

                {/* Excel Data Grid View */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                  <ExcelDataGrid
                    columns={[
                      { key: 'gstinMaster', label: 'GSTIN (Master)', type: 'text', width: '140px', required: true, disabled: !!activeClient },
                      { key: 'gstinCustomer', label: 'GSTIN (Customer)', type: 'text', width: '140px' },
                      { key: 'placeOfSupply', label: 'Place of Supply', type: 'select', width: '180px', options: placeOfSupplyOptions, required: true },
                      { key: 'invoiceType', label: 'Invoice Type', type: 'select', width: '200px', options: invoiceTypeOptions, required: true },
                      { key: 'invoiceNo', label: 'Invoice No', type: 'text', width: '120px', required: true },
                      { key: 'invoiceDate', label: 'Invoice Date', type: 'date', width: '100px', required: true, placeholder: 'DD-MM-YYYY' },
                      { key: 'invoiceValue', label: 'Item total', type: 'number', width: '100px', required: true, readOnly: true },
                      { key: 'taxableValue', label: 'Taxable Val', type: 'number', width: '100px', required: true },
                      { key: 'rate', label: 'Rate(%)', type: 'number', width: '80px', required: true },
                      { key: 'igst', label: 'IGST', type: 'number', width: '90px', readOnly: true },
                      { key: 'cgst', label: 'CGST', type: 'number', width: '90px', readOnly: true },
                      { key: 'sgst', label: 'SGST', type: 'number', width: '90px', readOnly: true },
                      { key: 'cess', label: 'Cess', type: 'number', width: '90px' },
                      { key: 'hsn', label: 'HSN', type: 'text', width: '80px', required: true },
                      { key: 'uqc', label: 'UQC', type: 'select', width: '80px', options: uqcOptions, required: true },
                      { key: 'quantity', label: 'Qty', type: 'number', width: '80px', required: true },
                      { key: 'reverseCharge', label: 'Rev Charge', type: 'select', width: '100px', options: reverseChargeOptions, required: true },
                    ]}
                    data={gstr1Data}
                    onDataChange={handleGridDataChange}
                    onRowAdd={handleGridRowAdd}
                    onRowDelete={handleGridRowDelete}
                    height="calc(100vh - 340px)"
                    stickyFirstColumn={true}
                  />

                  {gstr1Data.length === 0 && (
                    <div className="p-4 text-center text-gray-500 text-sm">
                      No data entries yet. Use the grid above or "Upload Excel" to add data.
                    </div>
                  )}
                </div>
              </>
            )}

            {/* Summary Tab Content */}
            {activeTab === 'summary' && (
              <div className="space-y-3">
                {/* GSTIN Selection */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Select GSTIN for Summary</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        GSTIN (Master)
                      </label>
                      <select
                        value={selectedGstinForSummary}
                        onChange={(e) => setSelectedGstinForSummary(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                      >
                        <option value="">Select GSTIN</option>
                        {getUniqueGstins().map(gstin => (
                          <option key={gstin} value={gstin}>{gstin}</option>
                        ))}
                      </select>
                    </div>
                    <div className="flex items-end">
                      <button
                        onClick={() => generateIndividualReturn(selectedGstinForSummary)}
                        disabled={!selectedGstinForSummary}
                        className={`w-full px-4 py-2 rounded-md font-medium transition-colors ${selectedGstinForSummary
                          ? 'bg-green-600 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500'
                          : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                          }`}
                      >
                        {selectedGstinForSummary
                          ? selectedGstinForSummary === 'All'
                            ? `Prepare All Returns (${getSelectedSectionsCount()} sections)`
                            : `Prepare Return (${getSelectedSectionsCount()} sections)`
                          : 'Prepare Return'
                        }
                      </button>
                    </div>
                  </div>
                </div>

                {/* Section Selection */}
                {selectedGstinForSummary && (
                  <div className="bg-white rounded-lg shadow p-4 mb-4">
                    <h3 className="text-lg font-semibold text-gray-900 mb-3">Select Sections for Return</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedSections.all}
                          onChange={(e) => handleSectionToggle('all', e.target.checked)}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500"
                        />
                        <span className="text-sm font-medium text-gray-700">All Sections</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedSections.b2b}
                          onChange={(e) => handleSectionToggle('b2b', e.target.checked)}
                          disabled={selectedSections.all}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500 disabled:opacity-50"
                        />
                        <span className="text-sm font-medium text-gray-700">B2B</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedSections.b2cl}
                          onChange={(e) => handleSectionToggle('b2cl', e.target.checked)}
                          disabled={selectedSections.all}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500 disabled:opacity-50"
                        />
                        <span className="text-sm font-medium text-gray-700">B2CL</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedSections.b2cs}
                          onChange={(e) => handleSectionToggle('b2cs', e.target.checked)}
                          disabled={selectedSections.all}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500 disabled:opacity-50"
                        />
                        <span className="text-sm font-medium text-gray-700">B2CS</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedSections.cdnr}
                          onChange={(e) => handleSectionToggle('cdnr', e.target.checked)}
                          disabled={selectedSections.all}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500 disabled:opacity-50"
                        />
                        <span className="text-sm font-medium text-gray-700">B2B Credit Notes</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedSections.cdnur}
                          onChange={(e) => handleSectionToggle('cdnur', e.target.checked)}
                          disabled={selectedSections.all}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500 disabled:opacity-50"
                        />
                        <span className="text-sm font-medium text-gray-700">B2CL Credit Notes</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedSections.hsn}
                          onChange={(e) => handleSectionToggle('hsn', e.target.checked)}
                          disabled={selectedSections.all}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500 disabled:opacity-50"
                        />
                        <span className="text-sm font-medium text-gray-700">HSN</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedSections.doc_issue}
                          onChange={(e) => handleSectionToggle('doc_issue', e.target.checked)}
                          disabled={selectedSections.all}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500 disabled:opacity-50"
                        />
                        <span className="text-sm font-medium text-gray-700">Invoice Details</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedSections.exp}
                          onChange={(e) => handleSectionToggle('exp', e.target.checked)}
                          disabled={selectedSections.all}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500 disabled:opacity-50"
                        />
                        <span className="text-sm font-medium text-gray-700">Export</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedSections.sezwp}
                          onChange={(e) => handleSectionToggle('sezwp', e.target.checked)}
                          disabled={selectedSections.all}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500 disabled:opacity-50"
                        />
                        <span className="text-sm font-medium text-gray-700">SEZ with Payment</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedSections.sezwop}
                          onChange={(e) => handleSectionToggle('sezwop', e.target.checked)}
                          disabled={selectedSections.all}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500 disabled:opacity-50"
                        />
                        <span className="text-sm font-medium text-gray-700">SEZ without Payment</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedSections.nil}
                          onChange={(e) => handleSectionToggle('nil', e.target.checked)}
                          disabled={selectedSections.all}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500 disabled:opacity-50"
                        />
                        <span className="text-sm font-medium text-gray-700">Nil-rated</span>
                      </label>
                    </div>
                  </div>
                )}

                {/* JSON Payload Summary Table */}
                {selectedGstinForSummary && getJsonPayloadSummary() && (
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4 overflow-hidden">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                      <span className="bg-purple-100 text-purple-700 p-1 rounded mr-2">
                        <EqualNot className="w-5 h-5" />
                      </span>
                      JSON Payload Summary
                    </h3>

                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50 text-gray-700">
                          <tr>
                            <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider sticky left-0 bg-gray-50 z-10 w-48">JSON Node</th>
                            <th className="px-4 py-3 text-center text-xs font-bold uppercase tracking-wider">Record Count</th>
                            <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider">Taxable Value</th>
                            <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider">IGST</th>
                            <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider">CGST</th>
                            <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider">SGST</th>
                            <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider">Cess</th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200 text-sm">
                          {/* JSON Categories */}
                          {[
                            { key: 'b2b', label: 'B2B Invoices', data: getJsonPayloadSummary().b2b },
                            { key: 'b2cl', label: 'B2C Large', data: getJsonPayloadSummary().b2cl },
                            { key: 'b2cs', label: 'B2C Small', data: getJsonPayloadSummary().b2cs },
                            { key: 'exp', label: 'Exports', data: getJsonPayloadSummary().exp },
                            { key: 'sezwp', label: 'SEZ (With Pay)', data: getJsonPayloadSummary().sezwp },
                            { key: 'sezwop', label: 'SEZ (Without Pay)', data: getJsonPayloadSummary().sezwop },
                            { key: 'nil', label: 'Nil / Exempt', data: getJsonPayloadSummary().nil },
                            { key: 'cdnr', label: 'Credit Notes (Reg)', data: getJsonPayloadSummary().cdnr },
                            { key: 'cdnur', label: 'Credit Notes (Unreg)', data: getJsonPayloadSummary().cdnur },
                            { key: 'hsn', label: 'HSN Summary', data: getJsonPayloadSummary().hsn },
                          ].filter(row => row.data && (row.data.count > 0 || row.data.taxableValue > 0)).map((row, idx) => (
                            <tr key={idx} className="hover:bg-gray-50">
                              <td className="px-4 py-2 font-medium sticky left-0 bg-white z-10 text-gray-900">
                                <div className="flex flex-col">
                                  <span className="text-xs text-purple-600 font-mono">"{row.key}"</span>
                                  <span>{row.label}</span>
                                </div>
                              </td>
                              <td className="px-4 py-2 text-center text-gray-600 font-mono">{row.data.count}</td>
                              <td className="px-4 py-2 text-right text-gray-600">₹{row.data.taxableValue.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                              <td className="px-4 py-2 text-right text-gray-600">₹{row.data.igst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                              <td className="px-4 py-2 text-right text-gray-600">₹{row.data.cgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                              <td className="px-4 py-2 text-right text-gray-600">₹{row.data.sgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                              <td className="px-4 py-2 text-right text-gray-600">₹{row.data.cess.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            </tr>
                          ))}

                          {/* Net Totals */}
                          <tr className="bg-blue-50 font-semibold border-t-2 border-blue-100">
                            <td className="px-4 py-3 text-blue-900 sticky left-0 bg-blue-50 z-10">Net Total (Invoices - CNs)</td>
                            <td className="px-4 py-3 text-center text-blue-900">-</td>
                            <td className="px-4 py-3 text-right text-blue-900">₹{getJsonPayloadSummary().combined.taxableValue.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            <td className="px-4 py-3 text-right text-blue-900">₹{getJsonPayloadSummary().combined.igst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            <td className="px-4 py-3 text-right text-blue-900">₹{getJsonPayloadSummary().combined.cgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            <td className="px-4 py-3 text-right text-blue-900">₹{getJsonPayloadSummary().combined.sgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            <td className="px-4 py-3 text-right text-blue-900">₹{getJsonPayloadSummary().combined.cess.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Document Issued Detail */}
                    {getJsonPayloadSummary().doc_issue.count > 0 && (
                      <div className="mt-6 border-t pt-4">
                        <h4 className="text-md font-semibold text-gray-800 mb-3 flex items-center">
                          <FileText className="w-4 h-4 mr-2 text-blue-600" />
                          Document Issued <span className="ml-2 text-xs text-purple-600 font-mono bg-purple-50 px-2 py-1 rounded">"doc_issue"</span>
                          <span className="ml-auto text-sm bg-blue-100 text-blue-800 px-2 py-1 rounded-full">Total Generated: {getJsonPayloadSummary().doc_issue.count}</span>
                        </h4>
                        <div className="grid gap-2">
                          {getJsonPayloadSummary().docDetails.map((det, idx) => (
                            <div key={idx} className="flex flex-col sm:flex-row sm:items-center bg-gray-50 p-2 rounded text-sm">
                              <span className="font-medium text-gray-700 w-48">{det.type}</span>
                              <span className="text-gray-600">{det.docs}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="mt-4 text-xs text-gray-500 italic px-2">
                      * This table displays the exact structure and aggregated totals of the JSON payload that will be generated.
                    </div>
                  </div>
                )}

                {/* Summary Data - HSN Detail Only */}
                {selectedGstinForSummary && getSummaryData() && (
                  <div className="space-y-3">
                    {/* HSN Summary */}
                    {getSummaryData().hsnSummary.length > 0 && (
                      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                          <span className="bg-blue-100 text-blue-700 p-1 rounded mr-2">
                            <FileText className="w-5 h-5" />
                          </span>
                          HSN-wise Details
                        </h3>
                        <div className="overflow-x-auto">
                          <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50 text-gray-700">
                              <tr>
                                <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider sticky left-0 bg-gray-50 z-10">HSN Description</th>
                                <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider">HSN No.</th>
                                <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider">UQC</th>
                                <th className="px-4 py-3 text-center text-xs font-bold uppercase tracking-wider">Qty</th>
                                <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider">Rate (%)</th>
                                <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider">Taxable Value</th>
                                <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider">IGST</th>
                                <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider">CGST</th>
                                <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider">SGST</th>
                                <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider">Cess</th>
                              </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200 text-sm">
                              {getSummaryData().hsnSummary.map((hsn, index) => (
                                <tr key={index} className="hover:bg-gray-50">
                                  <td className="px-4 py-2 text-gray-900 font-medium sticky left-0 bg-white z-10">
                                    {/* Placeholder for HSN description lookup if available in future */}
                                    <span className="text-gray-500 italic">--</span>
                                  </td>
                                  <td className="px-4 py-2 text-gray-900">{hsn.hsn}</td>
                                  <td className="px-4 py-2 text-gray-600">{hsn.uqc}</td>
                                  <td className="px-4 py-2 text-center text-gray-900">{hsn.quantity}</td>
                                  <td className="px-4 py-2 text-right text-gray-900">{hsn.rate}%</td>
                                  <td className="px-4 py-2 text-right text-gray-600">₹{hsn.taxableValue.toFixed(2)}</td>
                                  <td className="px-4 py-2 text-right text-gray-600">₹{hsn.igst.toFixed(2)}</td>
                                  <td className="px-4 py-2 text-right text-gray-600">₹{hsn.cgst.toFixed(2)}</td>
                                  <td className="px-4 py-2 text-right text-gray-600">₹{hsn.sgst.toFixed(2)}</td>
                                  <td className="px-4 py-2 text-right text-gray-600">₹{hsn.cess.toFixed(2)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {selectedGstinForSummary && !getSummaryData() && (
                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                    <p className="text-yellow-800">No data found for the selected GSTIN.</p>
                  </div>
                )}

                {!selectedGstinForSummary && (
                  <div className="bg-gray-50 border border-gray-200 rounded-lg p-8 text-center">
                    <p className="text-gray-600">Please select a GSTIN to view summary data.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </main>
      </div>
      <ToastContainer />
    </div>
  )
}

export default Gstr1Form
